import { Component,OnInit, OnDestroy, DoCheck, Renderer2} from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SortPipe } from '../_helpers/sort.pipe';
import { LazyLoadImgDirective } from '../_helpers/lazy-load-img.directive';
import { HelpsectionComponent } from '../helpsection/helpsection.component';
import { SuppliertabComponent } from '../suppliertab/suppliertab.component';
import { CommonService } from "../_service/common.service";
import { Subscription, Subject,interval, of } from "rxjs"; 
import { appConfig, baseUrl, dev, int, intUrl, localUrl, opeUrl, opewafUrl,opeNewwafUrl, share } from "../app.config";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { PagerService } from '../_service/pager-service';
import * as XLSX from 'xlsx';
import { SitesService } from "../_service/sites.service";
import { SupplierService } from "../_service/supplier.service";
import { CountryService } from "../_service/country.service";
import { AddressService } from "../_service/address.service";

@Component({
    selector: "app-sites",
    templateUrl: "./sites.component.html",
    styleUrls: ["./sites.component.css"],
    standalone: true,
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, RouterLink, RouterModule,
        MatIconModule, MatFormFieldModule, MatInputModule, MatAutocompleteModule,
        MatSelectModule, MatOptionModule, MatTooltipModule, MatProgressSpinnerModule,
        MatProgressBarModule, NgxPaginationModule, NgSelectModule, NgbModule,
        NgxMatSelectSearchModule, SortPipe, LazyLoadImgDirective,
        HelpsectionComponent, SuppliertabComponent
    ]
})
export class SitesComponent implements OnInit, OnDestroy, DoCheck {
  private static readonly ICONMOON_LABEL_CODE_POINT = 0xe07f;
  private static readonly ICONMOON_LABEL_IN_CODE_POINT = 0xe026;
  private static readonly DEBOUNCE_MS = 400;
  private static readonly PAGE_SIZE_STANDARD = 50;
  private static readonly TWENTY = 20;
  private static readonly MIN_SEARCH_LENGTH_SHORT = 3;
  private static readonly MIN_SEARCH_LENGTH_LONG = 4;
  private static readonly BATCH_START_DELAY_SEC = 5;
  private static readonly ONE_SECOND_MS = 1000;
  private static readonly SHORT_DELAY_MS = 200;
  private static readonly PAGE_COUNT_THRESHOLD = 10;
  private static readonly PAGE_HEIGHT_ROW_FACTOR = 30;
  private static readonly PAGE_HEIGHT_BASE_OFFSET = 300;
  private static readonly PAGE_HEIGHT_FALLBACK = 550;
  private static readonly ADDRESS_CHUNK_LENGTH = 35;
  private static readonly KEY_ENTER = 13;
  private static readonly TWO = 2;
  private static readonly SIX = 6;
  private static readonly TWENTY_FIVE = 25;
  private static readonly FIVE_THOUSAND_MS = 5000;
  private static readonly MINUTES_PER_DEGREE = 60;
  private static readonly SECONDS_PER_DEGREE = 3600;
  private static readonly DECIMAL_TENTH = 10;

  delayResponse = new UntypedFormControl();
  delayNameResponse = new UntypedFormControl();
  delayResCountry = new UntypedFormControl();
  delayResCity = new UntypedFormControl();
  delaySiteSearchResCity = new UntypedFormControl();
  delaySiteSearchResCountry = new UntypedFormControl();
  private ngUnsubscribe = new Subject();
  loading = false;
  Config: any;
  saveDatas: any = "Save";
  public sitesDataLists: any = [];
  public data: any = [];
  public sitesiDvalDropDown1: any = [];
  public sitesNameDropDown: any = [];
  public sitesNameModel: any = '';
  identifierTypeModel: string = "RAFT_CODE";
  identifierValueModel: any = '';
  
  sitesNameModellabel: string = "";
  
  listFlag = false;
  sitesids: any;
  sitesidNames: any;
  configa: any;
  forAccessQualifiers = [];l
  newAllianceRowId = [];
  sitesNameData =[];
  sortEnable = false;
  sortforAccess = false;
  public siteAdditionalAddressInfoModel: any = "";
  public siteAdditionalAddress: any = "";
  public siteAdditionalAddressInfo: any = "";
  public siteStreetModel: any = "";
  public siteCityModel: any = "";
  public siteCountryModel: any = "";
  public siteNameFieldModel: any = "";
  public siteShortNameFieldModel: any = "";
  public siteStreetModelError = false;
  public siteCityModelError = false;
  public siteCountryModelError = false;
  public siteNameFieldModelError = false;
  public siteShortNameFieldModelError = false;
  cityDisable  = true;
  public siteTypeChange = false;
  public newColorsDep = {
    'deleted':'#CB4B32','pending': '#B7783C','draft':'#CB4B32','active':'#5CBA63','validated':'#5CBA63','archived':'#CB4B32','':'white','greenfield': '#FFBD69', 'brownfield' : '#FFBD69',"destroyed": "#CB4B32", "built": "#5CBA63", "created":"#B7783C","identified": "#D8C4A0", 'pending_validation':'#FFBD69'
  }
  public newColors = { 'deleted':'#CB4B32',"archived": "#CB4B32", "active": "#5CBA63", "draft": "#CB4B32", "validated": "#5CBA63", "": 'white','pending_validation':'#FFBD69','pending' : '#B7783C', 'greenfield': '#FFBD69', 'brownfield': '#FFBD69', "destroyed": "#CB4B32", "built": "#5CBA63", "waiting for approval": "#B7783C", "created":"#B7783C","identified": "#D8C4A0", "inactive": "#FFBD69" }
  public workflowStatusColors = { "NotStarted": "#D8C4A0", "WaitingForSupplier": "#B7783C", "WaitingForRenault": "#B7783C", "Completed": "#5CBA63" }
  public colors = { "": "#D8C4A0", "approved": "#5CBA63", "identified": "#D8C4A0", "pending" : "#B7783C", "registered": "#66D8D0", "archived": "#CB4B32", "waiting for approval": "#B7783C", "prospect":"#4B9BF5" }
  public colorsGroup = { "": "#D8C4A0", "active": "#5CBA63", "inactive": "#FFBD69","pending" : "#B7783C", "archived": "#CB4B32", "blocked": "#D8C4A0","waiting for approval": "#B7783C","identified": "#D8C4A0" }
  public qualifierColors = {
    "P05": "#2E2ECA",
    "P06": "#244F35",
    "P07": "#978B7F",
    "P08": "#632717",
    "P09": "#4613A5",
    "P11": "#CB4B32",
    "P13": "#66D8D0",
    "P14": "#5CBA63",
    "P18": "#000000",
    "P19": "#B7783C",
    "B2b": "#000000"
  }
  public qualifierTypesText = {
    P05: "Manufacturing",
    P06: "Invoicing",
    P07: "Picking",
    P08: "Customer",
    P09: "Quality Return",
    P11: "Ordering",
    P13: "Grouping",
    P14: "Main Entrance",
    P18: "B2B Partner",
    P19: "Supply Chain EDI",
  };
  public qualifiersCount = ['P14','P18','P11','P05','P13','P19','P07','P09','P06','P08'];
  public P14_qualifier:boolean=false;public P11_qualifier:boolean=false;public P05_qualifier:boolean=false;public P13_qualifier:boolean=false;public P19_qualifier:boolean=false;
  public P07_qualifier:boolean=false;public P09_qualifier:boolean=false;public P06_qualifier:boolean=false;public P08_qualifier:boolean=false;
  P18_qualifier:boolean=false;
  public filterCheckQua = ['P14_qualifier','P18_qualifier','P11_qualifier','P05_qualifier','P13_qualifier','P19_qualifier','P07_qualifier','P09_qualifier','P06_qualifier','P08_qualifier'];

  public sortedQualifiers = {
    P14: "P14",
    P18: "B2bn",
    P11: "P11",
    P05: "P05",
    P13: "P13",
    P19: "P19",
    P07: "P07",
    P09: "P09",
    P06: "P06",
    P08: "P08",
    P100: "assets/sites/icons/P100.svg"
  };
  
  sitesData: any[] = [];
  businessEntityId:any = [];
  accessPointRowId = [];
  public envHide : any = "";

  pager: any = {};
  pagedItems: any[];
  paged:number = 1;
  pagedTotalItem:number=0;
  showPagination = false;
  maxPageSize = SitesComponent.PAGE_SIZE_STANDARD;

  public customLoadingTemplate2 : any;
  public roleVariable = '';
  public roleVariableHide = false;

  public CaptCountry : any = [];
  public CountryNameKeyId : any = [];
  public selectedCountry :any = "failed";
  public CaptCity : any = [];
  public CityNameKeyId : any = [];
  public selectedCity :any = "failed";
  public sitePostcodedModel : any = "";
  public sitePostcodeModelError = false;
  public accessPointDataBoolean = false;
  public gpsValueModelLat = '';
  public gpsValueModelLon = '';
  public booleanSiteStatus = false;
  public booleanSiteStatusName = false;
  public booleanSiteStatusBvd = false;
  public filterSiteModel = '';


  public sitesAssnBatchRowIds:any = [];
  public sitesAssnBatchAllData:any = [];
  public sitesAssnBatchRaftRow:any = [];
  public sitesAssnBatchRaftWithValue:any = [];
  public sitesAssnBatchAssignments:any = [];
  public aliasTextDisp = 'Loading Please Wait....';
  public showDownloadLog = false;
  public sitesAssnBatchAlcorData:any = [];
  public sitesAssnBatchLookCpyData:any = [];
  public siteAssnBatchOmitValues:any = [];
  public superUserShow : any = false;
  public siteAssnBatchraftRowIds:any = [];
  public pageBatchNo:any = '';
  public downloadDataLog = [];
  public progressForSiteAssignment = '0';
  public maxPageForSiteAssn = '';
  public cancelSiteBatchProcessing = false;
  public siteBatchExcelMainData = [];
  public siteBatchExcelAssignmentData = [];
  public siteAssnCpyBasedOnSiteVal:any = [];
  public siteAssnDataForNoExistAssn:any = [];
  public siteAssnDataForExistingAssn:any = [];
  public siteIdentifierRowIds: any = [];
  public newCategoryAssignment = '6'; //for categoryCode = B06;
  public newCategoryName = 'SUPPLIER SITE' //for category name
  

  public minSearchLengthIdentifier = SitesComponent.MIN_SEARCH_LENGTH_LONG;
  public BvDIdData = [];
  public siteAssignmentData:any = [];
  public accessPointDataNew:any = [];
  public businessIdOnSiteAssn:any = [];
  public siteRowIdsOnAccessPoint:any = [];
  public siteRowIdForSiteAssn:any = [];
  public siteRowIdOnSiteIden:any = [];
  public siteRowidOnSiteAssn:any = [];
  public gotKeyUpData = false;
  public accessPointIdsForRaft:any = [];
  public accessPointIdsForSaer:any = [];
  public accessPointIdsForC2b:any = [];
  public accessPointIdsForLatam:any = [];
  public accessPointIdsForRnaipl:any = [];
  public forRaftSiteIdentifier:any = [];
  public siteRowIdsForSiteIden:any = [];
  public siteAssnRowIdsIden: any = [];
  public prodHide = false;
  public territorialDivisionModel = '';
  public wayNumberModel = '';
  public showBuyerProfile : any = true;
  public sitesSearchCountryDropDown:any = [];
  public sitesSearchCityDropDown:any = [];
  public siteSearchCountryModel = '';
  public siteSearchCityModel = '';
  public siteSearchCityExists = '';
  public siteSearchCountryExists = '';
  public siteSearchCountryData:any=[];
  public siteSearchCityData:any=[];
  public siteSearchSelectedCountry :any = "failed";
  public siteSearchSelectedCity :any = "failed";
  public siteSearchCityDisable = true;
  public siteCityModelRegExError = false;
  public wayNumberModelRegExError = false;
  public siteStreetModelRegExError = false;
  public siteAdditionalAddressRegExError = false;
  public siteAdditionalAddressInfoRegExError = false;
  public sitePostcodedModelRegExError = false;
  public territorialDivisionModelRegExError = false;
  public showForConsult = false;
  public regExObjForSitesCreation = {
    siteCityModel : 'siteCityModelRegExError',
    wayNumberModel : 'wayNumberModelRegExError',
    siteStreetModel : 'siteStreetModelRegExError',
    siteAdditionalAddress : 'siteAdditionalAddressRegExError',
    siteAdditionalAddressInfo : 'siteAdditionalAddressInfoRegExError',
    sitePostcodedModel : 'sitePostcodedModelRegExError',
    territorialDivisionModel : 'territorialDivisionModelRegExError',
    siteNameFieldModel : 'siteNameModelRegExError',
    siteShortNameFieldModel : 'siteShortNameModelRegExError'
  }
  public sitesCreationModelObj = {
    siteCityModel : 'siteCityModelError',
    siteStreetModel : 'siteStreetModelError',
    sitePostcodedModel : 'sitePostcodeModelError',
    siteNameFieldModel : 'siteNameFieldModelError',
    siteShortNameFieldModel : 'siteShortNameFieldModelError'
  }
  stopAlcorCpyBatch = false;
  siteAssignmentDataAll: any=[];
  siteAssnRowIds :any=[];
  alcorValWithSiteRowId: any=[];
  tableDataForSiteAssnBatch: any=[];
  cpyDataOnAlcorVal: any = [];
  allCompanyData: any = [];
  sitesAllData: any=[];
  siteValueonAlcor: any=[];
  counterForTimeout: any;
  showForSupplier: boolean;
  siteBatchPageHolder = '';
  siteBatchIsRunning = false;
  disableSiteCreateBtn: boolean;
  selectedQualifierVal = '';
  toggleSelect2 = false;
  expiryTimeInMin:any='';
  subscription : Subscription;
  timerForBatchStart: any;
  siteNameModelRegExError = false;
  siteShortNameModelRegExError = false;
  canCallNextPageBatch = false;
  public showFilterQualifiers = false;
  public siteIdsForFilter:any = [];
  iconmoonLbl = String.fromCharCode(SitesComponent.ICONMOON_LABEL_CODE_POINT);
  iconmoonLblIn = String.fromCharCode(SitesComponent.ICONMOON_LABEL_IN_CODE_POINT);
  validationSuccess: boolean;
  citySelection = '';
  siteCreation = '';
  acpCreation = '';
  businessECreation = '';
  bvdAssoCreation = '';
  siteAssignCreation = '';
  siteNameUCreation = '';
  finalSiteCreation = '';
  loadingSteps = '<span><img src="assets/images/loading.gif" alt="loading..."></span>'
  successSteps = '<span class="text-success"> Success </span>';
  cityNewSteps = '<span class="text-success"> New City Created </span>';
  dangerSteps= '<span class="text-danger">';
  endSpanSteps = '</span>'
  batchObj: any={};
  varIsMergingSite = '2'; //by default value....
  siteRaftCodeValOnRowId :any = [];
  siteSaerCodeValOnRowId :any = [];
  accessPointIdOnAddress : any = [];
  acpAddressDetOnRows :any = [];
  siteRowIdsOnMainEntrance :any = [];
  nissanCodeValues : any;
  statusDropdown = false;
  CompanyStatusAll: any = [];
  selectedStatusModel = '';
  workflowDropdown = false;
  selectedWorkflowStatusModel = '';
  WorkflowStatusAll = ['NotStarted', 'WaitingForSupplier', 'WaitingForRenault', 'Completed'];


  fileToUpload: File = null;

  arrayOfObjects:any;
  rowLength:any;
  public nissanValues=[];
  public rowIdQua = [];
  headers:any;
  public siteIdentTypesData:any = [];
  pageHeight:number = 0;
  public dataForDispCountryInfo = [];
  countryInfoLoading = false;
  FactoriescodeLoading=false;
  public uniquefactcode: any =[]; 
  public uniquefactNameAndCode: any[];
  TextForCompleteUpload: any='';
  logFileArrayOfUploadErrors: any = [];  
  public showDownloadLogForNissan = false;  

  /**Add Main Entrance batch */
  timerForMainEntrBatchStart: any;
  mainEntrBatchPageHolder = '';
  stopMainEntrBatch = false;
  mainEntrBatchIsRunning = false;
  batchObjs: any={};
  public mainEntrTextDisp = 'Loading Please Wait....';
  public mainEntrpageBatchNo:any = '';
  public showDownloadLogForMainEntr = false;
  public mainEntranceExists = false;
  logFileArrayOfAddMainEntrErrors: any = [];
  filteredStatushighlight = false;
  public latDegVal = '';
  public latMinVal = '';
  public latSecVal = '';
  public northSouthModel = '';
  public longDegVal = '';
  public longMinVal = '';
  public longSecVal = '';
  public eastWestModel = '';
  businessEntityIdforTax:any = [];
  TaxData: any[];
  key: string = 'name'; //set default
  reverse = false;
  autoload = false;
  siteNamesDropDown = [];
  public keyword = 'name'
  siteSearchCountryDatas= []
  countryLoad = false;
  cityLoad = false;
  enterKey: boolean=false;
  identifierLoad: boolean;
  countryLoad1: boolean;
  cityLoad1: boolean;
  totalItems: number;
  currentPage: number = 1;
  p = 1;
  itemsPerPage = SitesComponent.PAGE_SIZE_STANDARD
  paginatedSites: any[];
  siteC2bCodeValOnRowId: any = [];
  siteLatamCodeValOnRowId: any = [];
  siteRnaiplCodeValOnRowId: any = [];
  roleIsManager: boolean;
  factPager: any = {};
  constructor(public apiService: CommonService,private siteServices:SitesService,private supplierService:SupplierService,private countryService:CountryService,private addressService:AddressService, private pagerService: PagerService, private router: Router, private renderer: Renderer2 ) {
    this.Config = appConfig;
    this.configa = {
      itemsPerPage: SitesComponent.PAGE_SIZE_STANDARD,
      currentPage: 1,
      totalItems: this.sitesDataLists.length
    };

    this.apiService.matomoCall('sites','ISA - MANAGE SITE DATA');
  }
  pageChanged(event) {
     this.configa.currentPage = event;

  }


  ngOnInit() {
    this.loading = false;
    this.sitesids = {};
    this.sitesidNames = {};

    this.delayResponse.valueChanges.pipe(debounceTime(SitesComponent.DEBOUNCE_MS), distinctUntilChanged()).subscribe(sat => {
      this.identifierValueModel=sat
      this.OnkeyDownNg2Fn();
    });

    this.delayNameResponse.valueChanges.pipe(debounceTime(SitesComponent.DEBOUNCE_MS), distinctUntilChanged()).subscribe(sat => {
      this.sitesNameModel=sat
      this.OnKeyDownForSiteName(1,'');
    });

    this.delayResCountry.valueChanges.pipe(debounceTime(SitesComponent.DEBOUNCE_MS), distinctUntilChanged()).subscribe(sat => {
      this.siteCountryModel=sat
      this.getCountriesList(this.siteCountryModel);
    });

    this.delayResCity.valueChanges.pipe(debounceTime(SitesComponent.DEBOUNCE_MS), distinctUntilChanged()).subscribe(sat => {
      this.siteCityModel=sat
      this.getCityList(this.siteCityModel);
    });
    this.delaySiteSearchResCountry.valueChanges.pipe(debounceTime(SitesComponent.DEBOUNCE_MS), distinctUntilChanged()).subscribe(sat => {
      this.siteSearchCountryModel=sat
      this.getSiteSearchCountriesList(this.siteSearchCountryModel);
    });
    this.delaySiteSearchResCity.valueChanges.pipe(debounceTime(SitesComponent.DEBOUNCE_MS), distinctUntilChanged()).subscribe(sat => {
      this.siteSearchCityModel=sat





      this.getSiteSearchCityList(this.siteSearchCityModel);
    });



  
  }

  ngDoCheck() {
    this.getRoles();
  }

  getRoles() {
    let RoleByService = this.apiService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);
  }
  
  checkAllProfilesAndEnv(RoleByService){
    let c = RoleByService;

    if(c['userAccess']!=undefined && !c['userAccess'].includes('Deined')) {
      if(c['buyer'] == 'yes'){
        this.showBuyerProfile = false;
      }else{
        this.showBuyerProfile = true;
      }
      if (c['role'].includes('manager') ) {
        this.roleIsManager = true;
      } else {
        this.roleIsManager = false;
      }
      if(c['env'] =='qua' || c['env'] == 're7' || c['env'] == 'ope'){
        this.envHide = false;
      }else{
        this.envHide = true;
      }
      if(c['role'] == 'admin' || c['role'].includes('admin')){
        this.roleVariableHide = true;
      }else{
        this.roleVariableHide = false;
      }
      if(c['superAdmin'] == 'yes'){
        this.superUserShow = true;
      }else{
        this.superUserShow = false;
      }
      if(c['role'] == 'consult' || c['role'].includes('consult')){
        this.showForConsult = false;
      }else{
        this.showForConsult = true;
      }
      if(c['env'] == 'ope' && this.superUserShow == false){
        this.prodHide = true;
      }else{this.prodHide = false;}






      if(c['role'] == 'supplier'){
        this.showForSupplier = false;
      }else{
        this.showForSupplier = true;
      }
    }
    
  }

  onCountryInput(event: Event, control: UntypedFormControl) {
    const input = event.target as HTMLInputElement;
    const uppercaseValue = input.value.toUpperCase();
    if (input.value !== uppercaseValue) {
      input.value = uppercaseValue;
      control.setValue(uppercaseValue, { emitEvent: false });
    }
  }


  siteBatchStartCheckOnStart(){
    this.timerForBatchStart = SitesComponent.BATCH_START_DELAY_SEC;
    let checkVar = localStorage.getItem('siteBatchRunning');
    let isProcess = localStorage.getItem('siteBatchProcessingPage');
    if(checkVar == 'yes'){
      this.siteBatchPageHolder = isProcess;
      document.getElementById('BtnForshowConfirmStartBatchOnStart').click();
      const source = interval(SitesComponent.ONE_SECOND_MS);
      this.subscription = source.subscribe(_val => {
        this.timerForBatchStart = this.timerForBatchStart - 1;
        if(this.timerForBatchStart == 0){
          document.getElementById('closeSiteStartBatch').click();
          this.siteAssnBatchFn(+isProcess,'continue',SitesComponent.TWENTY,undefined);
          this.subscription.unsubscribe();
        }
      });
    }
  }

  stopSiteBatchAssnExe(){
    this.subscription.unsubscribe();
    this.stopAlcorCpyBatch = true;
    this.siteBatchIsRunning = false;
    localStorage.setItem('siteBatchRunning','no');
  }
  
  showDropdownQualifiers(dos='main'){
    if(dos == 'close'){
      this.filterCheckQua.forEach(ele => {
        this[ele] = false;
      });
    }else{
      this.showFilterQualifiers = !this.showFilterQualifiers;
    }
    setTimeout(function(){
      this.filterCheckQua.forEach(ele => {
        let type = ele.split('_');
        if(this[ele] == true){

          document.getElementById(type[0]).setAttribute('checked','');
        }else{

          document.getElementById(type[0]).removeAttribute('checked');
        }
      });
      if(dos == 'close'){
        this.filterQualifiers();
      }
    }.bind(this),SitesComponent.SHORT_DELAY_MS)
  }





  clearAllArrays(){
    this.accessPointRowId = [];
    this.sitesiDvalDropDown1 = [];
  }



  OnkeyDownNg2Fn(page=1,from='none'){ //key down for auto complete...
    if(this.identifierValueModel.length >= this.minSearchLengthIdentifier){
      this.listFlag = false;
      this.gotKeyUpData = false;
      this.sitesiDvalDropDown1 = [];
      this.businessEntityId = [];
      this.sitesData = [];
      this.siteTypeChange = false;
      this.acpAddressDetOnRows = [];
      this.accessPointIdOnAddress = [];
      this.accessPointIdsForRaft = [];
      this.accessPointIdsForSaer=[]
      this.accessPointIdsForC2b=[]
      this.accessPointIdsForLatam=[]
      this.accessPointIdsForRnaipl=[]
      if(from == 'pagination'){
        this.loading = true;
        this.listFlag = false;
      }
      console.info('<<<<<<<Searching Value>>>>>>>');
      let type = this.identifierTypeModel;
      if(type == 'access-points'){
        this.keyUpGetAllianceQualifier(page,from);
      }else if(type == 'allianceSiteId'){
        this.keyUpGetSiteIdentifier(page,from);
      }else if(type == 'BVDID'){
        this.keyUpGetBvDData(page,from);
      }else if(type == 'RAFT_CODE'){
        this.keyUpGetRaftAliasData(page,from);
      }else if(type == 'AP_C2B_CODE'){
        this.keyUpGetC2bData(page,from);
      }
      else if(type == 'vendor-code'){
        this.keyUpGetVendorCodeData(page,from);
      }else if(type == 'SAER_CODE'){
        this.keyUpGetSaerAliasData(page,from)
      }else if(type == 'AP_LATAM_CODE'){
        this.keyUpGetLatamAliasData(page,from)
      }else if(type == 'AP_RNAIPL_CODE'){
        this.keyUpGetRnaiplAliasData(page,from)
      }
      else if(type == 'TaxID'){
        this.keyUpGetTaxData(page,from);
        console.info("type",type)
      }
    }
  }

  OnKeyDownForSiteName(page=1,from='none'){
    let searchV = this.sitesNameModel.toLowerCase().trim();
    this.sitesData = [];
    this.sitesNameDropDown = [];
    this.gotKeyUpData = false;
    this.listFlag = false;
    this.acpAddressDetOnRows = [];
    this.accessPointIdOnAddress = [];
    this.accessPointIdsForRaft = [];
    this.accessPointIdsForSaer =[];
    this.accessPointIdsForC2b=[];
    this.accessPointIdsForLatam=[];
    this.accessPointIdsForRnaipl=[];
    let countryQuery = '';
    let cityQuery = '';
    let siteNameQuery = '';
    if(this.sitesNameModel!='' && this.siteSearchCountryModel == ''){
      this.autoload = true 
    }
    if(searchV.length >= SitesComponent.MIN_SEARCH_LENGTH_SHORT){
      siteNameQuery = `&name=*${encodeURIComponent(searchV)}*`;
    }
    if(this.siteSearchCountryModel != '' && this.siteSearchSelectedCountry != 'failed'){
      let split=this.siteSearchCountryModel.split(" - ");
      countryQuery = `&countryName=${split[1]}`;
    }else{
      this.siteSearchCountryModel = '';
    }
    if(this.siteSearchCityModel != '' && this.siteSearchSelectedCity != 'failed'){
      cityQuery = `&cityName=${this.siteSearchCityModel}`;
    }else{
      this.siteSearchCityModel = '';
    }
    if(from == 'pagination'){
      this.loading = true;
      this.listFlag = false;
    }
    if(siteNameQuery!= '' || ((countryQuery != '' || cityQuery != '') && this.siteSearchSelectedCountry != 'failed')){
      this.siteServices.getSites(`${this.Config.ApiSitesUrl}sites?_page=${page}${siteNameQuery}${countryQuery}${cityQuery}&_pagesize=${this.maxPageSize}`).subscribe( data => {
        this.siteAssnRowIdsIden = "";
        this.siteAssnRowIdsIden = [];
        this.siteRowIdsForSiteIden = "";
        this.siteRowIdsForSiteIden = [];
        this.siteIdsForFilter = [];
        this.sitesData = [];
        if(data['pageCount'] > 0){
          this.gotKeyUpData = true;
          this.pagedTotalItem = data['count'];
          this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
          if(data['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
            this.pageHeight = data['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
          }else{
            this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
          }

          data['sites'].forEach(element =>{
            element['filterTrue'] = true;
            this.sitesData.push(element);
            this.sitesNameDropDown.push(element.name)
            this.siteAssnRowIdsIden.push(`'SupSiteService:${element.rowId}'`);
            this.siteRowIdsForSiteIden.push(element.rowId);
            this.siteIdsForFilter.push(element.rowId);
            if(this.accessPointIdsForRaft.indexOf(`'${element.identifier}'`) == -1){
              this.accessPointIdsForRaft.push(`'${element.identifier}'`);
            }
            if(this.accessPointIdsForSaer.indexOf(`'${element.identifier}'`) == -1){
              this.accessPointIdsForSaer.push(`'${element.identifier}'`);
            }
            if(this.accessPointIdsForLatam.indexOf(`'${element.identifier}'`) == -1){
              this.accessPointIdsForLatam.push(`'${element.identifier}'`);
            }
            if(this.accessPointIdsForRnaipl.indexOf(`'${element.identifier}'`) == -1){
              this.accessPointIdsForRnaipl.push(`'${element.identifier}'`);
            }
            if(this.accessPointIdsForC2b.indexOf(`'${element.identifier}'`) == -1){
              this.accessPointIdsForC2b.push(`'${element.identifier}'`);
            }
            this.autoload=false;
          });
          if(this.sitesNameDropDown.length > 0){
            this.siteNamesDropDown=this.sitesNameDropDown
          }
        }else{
          this.loading = false;
          this.autoload = false;
          this.siteNamesDropDown=this.sitesNameDropDown
        }
        if(from == 'pagination'){
          this.getSiteAssignmentData(this.siteAssnRowIdsIden,page,'first','iden');
          this.getAccessPointData(this.siteRowIdsForSiteIden,page,'second','iden');
          this.getSiteRaftCodes(this.accessPointIdsForRaft);
          this.getSiteSaerCodes(this.accessPointIdsForSaer);
          this.getSiteLatamCodes(this.accessPointIdsForLatam);
          this.getSiteRnaiplCodes(this.accessPointIdsForRnaipl);
          this.getSiteC2bCodes(this.accessPointIdsForC2b);
          this.listFlag = true;
        }
      },_error => {
        this.autoload = false
        this.siteNamesDropDown=this.sitesNameDropDown
      });
    }else{
      this.loading = false;
      this.autoload = false
      this.siteNamesDropDown=this.sitesNameDropDown
    }
  }

  searchSiteIdentifierEnter(page=1){ //when user presses ENTER Key
    console.info(this.siteTypeChange);
    if(this.identifierValueModel.length >= this.minSearchLengthIdentifier && this.gotKeyUpData == true && this.siteTypeChange == false){
      this.loading = true;
      console.info('<<<<<<Loading Data...>>>>>>>');
      let type = this.identifierTypeModel;
      if(type == 'access-points'){
        this.getSitesData(this.siteRowIdsOnAccessPoint,page,'first','no');
        this.getAccessPointData(this.siteRowIdsOnAccessPoint,page,'second','no')
        this.getSiteAssignmentData(this.siteRowIdForSiteAssn,page,'final','accesspoints');

      }else if(type == 'allianceSiteId'){
        this.getSiteAssignmentData(this.siteAssnRowIdsIden,page,'first','iden');
        this.getAccessPointData(this.siteRowIdsForSiteIden,page,'second','iden');
        this.getSiteRaftCodes(this.accessPointIdsForRaft);
        this.getSiteSaerCodes(this.accessPointIdsForSaer);
        this.getSiteLatamCodes(this.accessPointIdsForLatam);
        this.getSiteRnaiplCodes(this.accessPointIdsForRnaipl);
        this.getSiteC2bCodes(this.accessPointIdsForC2b)
      }else if(type == 'BVDID'){
        this.getSiteAssignmentData(this.businessEntityId,page,'first','bvd');
      }else if(type == 'RAFT_CODE' || type == 'vendor-code'){
        this.getAccessPointData(this.accessPointIdsForRaft,page,'first','raft');
      }else if(type == 'SAER_CODE'){
        this.getAccessPointData(this.accessPointIdsForSaer,page,'first','saer');
      }else if(type == 'AP_LATAM_CODE'){
        this.getAccessPointData(this.accessPointIdsForLatam,page,'first','latam');
      }else if(type == 'AP_C2B_CODE'){
        this.getAccessPointData(this.accessPointIdsForC2b,page,'first','c2b');
      }else if(type == 'AP_RNAIPL_CODE'){
        this.getAccessPointData(this.accessPointIdsForRnaipl,page,'first','rnaipl');
      }else if(type == 'TaxID'){
        this.getSiteAssignmentData(this.businessEntityIdforTax,page,'first','tax');
      }
    }else if(this.siteTypeChange == true){
      this.OnkeyDownNg2Fn(1,'pagination');
    }else{
      this.loading =false;
    }
  }

  searchSiteNameEnter(page=1,from=''){
    if(((this.sitesNameModel.trim().length >= SitesComponent.MIN_SEARCH_LENGTH_SHORT || this.siteSearchCountryModel.trim().length >= 3) && this.gotKeyUpData == true) || from == 'noFilter'){
      this.loading = true;
      this.getSiteAssignmentData(this.siteAssnRowIdsIden,page,'first','iden');
      this.getAccessPointData(this.siteRowIdsForSiteIden,page,'second','iden');
      this.getSiteRaftCodes(this.accessPointIdsForRaft);
      this.getSiteSaerCodes(this.accessPointIdsForSaer);
      this.getSiteLatamCodes(this.accessPointIdsForLatam);
      this.getSiteRnaiplCodes(this.accessPointIdsForRnaipl);
      this.getSiteC2bCodes(this.accessPointIdsForC2b)
    }else{
      this.OnKeyDownForSiteName(page,'pagination');
    }
  }

  keyUpGetBvDData(page=1,from){
    let searchV = this.identifierValueModel.toLowerCase().trim();
    this.identifierLoad=true
    this.supplierService.getBusinessEntityIdentifiers(
      `${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=*${searchV.trim()}*&_page=${page}&_pagesize=${this.maxPageSize}`
          ).subscribe(data0 => {
            this.businessEntityId = "";
            this.businessEntityId = [];
            this.BvDIdData = [];
            if(data0['pageCount'] > 0){
              this.gotKeyUpData = true;
              data0['business-entity-identifiers'].forEach(element => {
                this.sitesiDvalDropDown1.push(element.value);
                if(this.businessEntityId.indexOf(element.businessEntityId) == -1) {
                  this.businessEntityId.push(element.businessEntityId);
                  this.BvDIdData[element.businessEntityId] = element.value;
                }
                this.identifierLoad=false
              });
              this.pagedTotalItem = data0['count'];
              this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
              if(data0['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
                this.pageHeight = data0['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
              }else{
                this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
              }
            }else{
              this.noDataShown();
            }
            console.info(this.BvDIdData);
            if(from == 'pagination'){
              this.searchSiteIdentifierEnter(page);
            }
          });
  }
  keyUpGetTaxData(page=1,from){
    let searchV = this.identifierValueModel.toLowerCase().trim();
    this.identifierLoad=true
    this.supplierService.getBusinessEntityIdentifiers(
      `${this.Config.ApiSupplierUrl}business-entity-identifiers?value=*${searchV.trim()}*&_page=${page}&_pagesize=${this.maxPageSize}`
          ).subscribe(data0 => {

            this.businessEntityIdforTax = "";
            this.businessEntityIdforTax = [];
            this.TaxData = [];
            if(data0['pageCount'] > 0){
              this.gotKeyUpData = true;
              data0['business-entity-identifiers'].forEach(element => {
                if(element.businessEntityIdentifierTypeName !='BVD ID' && element.businessEntityIdentifierTypeName !='DUNS'){
                this.sitesiDvalDropDown1.push(element.value);
                if(this.businessEntityIdforTax.indexOf(element.businessEntityId) == -1) {
                  this.businessEntityIdforTax.push(element.businessEntityId);
                  this.TaxData[element.businessEntityId] = element.value;
                }
                this.identifierLoad=false
              }
              });
              this.pagedTotalItem = data0['count'];
              this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
              if(data0['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
                this.pageHeight = data0['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
              }else{
                this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
              }
            }else{
              this.noDataShown();
            }
            console.info(this.TaxData);
            if(from == 'pagination'){
              this.searchSiteIdentifierEnter(page);
            }
          });
  }


  keyUpGetAllianceQualifier(page =1,from){
    let searchV = this.identifierValueModel.toLowerCase().trim();
    this.identifierLoad=true
    this.siteServices.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?identifier=*${searchV}*&_page=${page}&_pagesize=${this.maxPageSize}`).subscribe(data0 => {
      if(data0['access-points'].length > 0){
        this.gotKeyUpData = true;
        this.accessPointDataNew = "";
        this.accessPointDataNew = [];
        this.siteRowIdsOnAccessPoint = "";
        this.siteRowIdsOnAccessPoint = [];
        this.siteRowIdForSiteAssn = [];
        data0['access-points'].forEach(element => {
          this.sitesiDvalDropDown1.push(element.identifier);
          this.siteRowIdsOnAccessPoint.push(element.realEstateAssetId);
          this.siteRowIdForSiteAssn.push(`'SupSiteService:${element.realEstateAssetId}'`);
          this.siteRowIdOnSiteIden[`'${element.siteIdentifier}'`] = element.realEstateAssetId;
          if(this.accessPointIdsForRaft.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForRaft.push(`'${element.identifier}'`);
          }
          this.identifierLoad=false
        });
        this.pagedTotalItem = data0['count'];
        this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
        if(data0['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
          this.pageHeight = data0['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
        }else{
          this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
        }
      }else{
        this.noDataShown();
      }
      if(from == 'pagination'){
        this.searchSiteIdentifierEnter(page);
      }
    });
  }

  keyUpGetRaftAliasData(page=1,from){
    let searchV = this.identifierValueModel.toLowerCase().trim();
    this.identifierLoad=true
    this.siteServices.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=RAFT_CODE&identifierValue=*${searchV}*&_page=${page}&_pagesize=${this.maxPageSize}`).subscribe(data3 => {
      this.accessPointRowId = [];
      this.accessPointIdsForRaft = "";
      this.accessPointIdsForRaft = [];
      if(data3['pageCount'] > 0){
        this.gotKeyUpData = true;
        data3['access-point-identifiers'].forEach(element2 => {
          if(this.accessPointRowId.indexOf(element2.accessPointIdentifier) == -1){
            this.accessPointRowId.push(element2.accessPointIdentifier);
          }
          this.accessPointIdsForRaft.push(`'${element2.siteIdentifier}'`);
          this.sitesiDvalDropDown1.push(element2.identifierValue);
          this.identifierLoad=false
        });
        this.pagedTotalItem = data3['count'];
        this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
        if(data3['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
          this.pageHeight = data3['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
        }else{
          this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
        }
        if(from == 'pagination'){
          this.getAccessPointData(this.accessPointIdsForRaft,page,'first','raft');
        }
      }else{
        this.noDataShown();
      }
    });
  }

  keyUpGetC2bData(page=1,from){
    let searchV = this.identifierValueModel.toLowerCase().trim();
    this.identifierLoad=true
    this.siteServices.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_C2B_CODE&identifierValue=*${searchV}*&_page=${page}&_pagesize=${this.maxPageSize}`).subscribe(data3 => {
      this.accessPointRowId = [];
      this.accessPointIdsForC2b = "";
      this.accessPointIdsForC2b = [];
      if(data3['pageCount'] > 0){
        this.gotKeyUpData = true;
        data3['access-point-identifiers'].forEach(element2 => {
          if(this.accessPointRowId.indexOf(element2.accessPointIdentifier) == -1){
            this.accessPointRowId.push(element2.accessPointIdentifier);
          }
          this.accessPointIdsForC2b.push(`'${element2.siteIdentifier}'`);
          this.sitesiDvalDropDown1.push(element2.identifierValue);
          this.identifierLoad=false
        });
        this.pagedTotalItem = data3['count'];
        this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.TWENTY);
        if(data3['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
          this.pageHeight = data3['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
        }else{
          this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
        }
        if(from == 'pagination'){
          this.getAccessPointData(this.accessPointIdsForC2b,page,'first','c2b');
        }
      }else{
        this.noDataShown();
      }
    });
  }

  keyUpGetSaerAliasData(page=1,from){
    let searchV = this.identifierValueModel.toLowerCase().trim();
    this.identifierLoad=true
    console.info("searchV",searchV)
    this.siteServices.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=SAER_CODE&identifierValue=*${searchV}*&_page=${page}&_pagesize=${this.maxPageSize}`).subscribe(data3 => {
      this.accessPointRowId = [];
      this.accessPointIdsForSaer = "";
      this.accessPointIdsForSaer = [];
      if(data3['pageCount'] > 0){
        this.gotKeyUpData = true;
        data3['access-point-identifiers'].forEach(element2 => {
          if(this.accessPointRowId.indexOf(element2.accessPointIdentifier) == -1){
            this.accessPointRowId.push(element2.accessPointIdentifier);
          }
          this.accessPointIdsForSaer.push(`'${element2.siteIdentifier}'`);
          this.sitesiDvalDropDown1.push(element2.identifierValue);
          this.identifierLoad=false
        });
        this.pagedTotalItem = data3['count'];
        this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
        if(data3['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
          this.pageHeight = data3['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
        }else{
          this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
        }
        if(from == 'pagination'){
          this.getAccessPointData(this.accessPointIdsForSaer,page,'first','saer');
        }
      }else{
        this.noDataShown();
      }
    });
  }

  keyUpGetLatamAliasData(page=1,from) {
    let searchV = this.identifierValueModel.toLowerCase().trim();
    this.identifierLoad=true
    console.info("searchV",searchV)
    this.siteServices.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_LATAM_CODE&identifierValue=*${searchV}*&_page=${page}&_pagesize=${this.maxPageSize}`).subscribe(data3 => {
      this.accessPointRowId = [];
      this.accessPointIdsForLatam = "";
      this.accessPointIdsForLatam = [];
      this.accessPointIdsForRnaipl = "";
      this.accessPointIdsForRnaipl = [];
      if(data3['pageCount'] > 0){
        this.gotKeyUpData = true;
        data3['access-point-identifiers'].forEach(element2 => {
          if(this.accessPointRowId.indexOf(element2.accessPointIdentifier) == -1){
            this.accessPointRowId.push(element2.accessPointIdentifier);
          }
          this.accessPointIdsForLatam.push(`'${element2.siteIdentifier}'`);
          this.accessPointIdsForRnaipl.push(`'${element2.siteIdentifier}'`);
          this.sitesiDvalDropDown1.push(element2.identifierValue);
          this.identifierLoad=false
        });
        this.pagedTotalItem = data3['count'];
        this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
        if(data3['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
          this.pageHeight = data3['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
        }else{
          this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
        }
        if(from == 'pagination'){
          this.getAccessPointData(this.accessPointIdsForLatam,page,'first','latam');
        }
      }else{
        this.noDataShown();
      }
    });
  }

  keyUpGetRnaiplAliasData(page=1,from) {
    let searchV = this.identifierValueModel.toLowerCase().trim();
    this.identifierLoad=true
    this.siteServices.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_RNAIPL_CODE&identifierValue=*${searchV}*&_page=${page}&_pagesize=${this.maxPageSize}`).subscribe(data3 => {
      this.accessPointRowId = [];
      this.accessPointIdsForRnaipl = "";
      this.accessPointIdsForRnaipl = [];
      if(data3['pageCount'] > 0){
        this.gotKeyUpData = true;
        data3['access-point-identifiers'].forEach(element2 => {
          if(this.accessPointRowId.indexOf(element2.accessPointIdentifier) == -1){
            this.accessPointRowId.push(element2.accessPointIdentifier);
          }
          this.accessPointIdsForRnaipl.push(`'${element2.siteIdentifier}'`);
          this.sitesiDvalDropDown1.push(element2.identifierValue);
          this.identifierLoad=false
        });
        this.pagedTotalItem = data3['count'];
        this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
        if(data3['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
          this.pageHeight = data3['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
        }else{
          this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
        }
        if(from == 'pagination'){
          this.getAccessPointData(this.accessPointIdsForRnaipl,page,'first','rnaipl');
        }
      }else{
        this.noDataShown();
      }
    });
  }

  getSiteLatamCodes(rowIds,page=1,splitrowids=[],morethan20rec = false,remainingRows=[]) {
    if(rowIds.length > 0){
      if(rowIds.length > SitesComponent.TWENTY){
        splitrowids = rowIds.slice(0,SitesComponent.TWENTY);
        remainingRows = rowIds.slice(SitesComponent.TWENTY,rowIds.length);
        morethan20rec = true;
      }else{
        morethan20rec = false;
        splitrowids = rowIds;
      }
      this.siteServices.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_LATAM_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {        
        if(data['access-point-identifiers'].length > 0){
          data['access-point-identifiers'].forEach(e => {
            if(this.siteLatamCodeValOnRowId[e.siteIdentifier] == undefined){
              this.siteLatamCodeValOnRowId[e.siteIdentifier] = [];
            }
            if(this.siteLatamCodeValOnRowId[e.siteIdentifier].indexOf(e.identifierValue) == -1){
              this.siteLatamCodeValOnRowId[e.siteIdentifier].push(e.identifierValue);
            }
          });
        }
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getSiteLatamCodes(rowIds,page+1);
        }else if(data['maxPage'] == page){
          console.info("this.siteLatamCodeValOnRowId",this.siteLatamCodeValOnRowId)
          if(morethan20rec == true){
            this.getSiteLatamCodes(remainingRows,1,splitrowids,morethan20rec,remainingRows);
          }
        }
      });
    }
  }

  getSiteRnaiplCodes(rowIds,page=1,splitrowids=[],morethan20rec = false,remainingRows=[]) {
    if(rowIds.length > 0){
      if(rowIds.length > SitesComponent.TWENTY){
        splitrowids = rowIds.slice(0,SitesComponent.TWENTY);
        remainingRows = rowIds.slice(SitesComponent.TWENTY,rowIds.length);
        morethan20rec = true;
      }else{
        morethan20rec = false;
        splitrowids = rowIds;
      }
      this.siteServices.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_RNAIPL_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {
        if(data['access-point-identifiers'].length > 0){
          data['access-point-identifiers'].forEach(e => {
            if(this.siteRnaiplCodeValOnRowId[e.siteIdentifier] == undefined){
              this.siteRnaiplCodeValOnRowId[e.siteIdentifier] = [];
            }
            if(this.siteRnaiplCodeValOnRowId[e.siteIdentifier].indexOf(e.identifierValue) == -1){
              this.siteRnaiplCodeValOnRowId[e.siteIdentifier].push(e.identifierValue);
            }
          });
        }
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getSiteRnaiplCodes(rowIds,page+1);
        }else if(data['maxPage'] == page){
          if(morethan20rec == true){
            this.getSiteRnaiplCodes(remainingRows,1,splitrowids,morethan20rec,remainingRows);
          }
        }
      });
    }
  }

  keyUpGetSiteIdentifier(page=1,from){
    let searchV = this.identifierValueModel.toLowerCase().trim();
    this.identifierLoad=true
    this.siteServices.getSites(`${this.Config.ApiSitesUrl}sites?identifier=*${searchV}*&_page=${page}&_pagesize=${this.maxPageSize}`).subscribe(data0 => {
      this.siteAssnRowIdsIden = "";
      this.siteAssnRowIdsIden = [];
      this.siteRowIdsForSiteIden = "";
      this.siteRowIdsForSiteIden = [];
      this.sitesData = [];
      if(data0['sites'].length > 0){
        this.gotKeyUpData = true;

        data0['sites'].forEach(element => {
          element['filterTrue'] = true;
          this.sitesData.push(element);
          this.sitesiDvalDropDown1.push(element.identifier);
          this.siteAssnRowIdsIden.push(`'SupSiteService:${element.rowId}'`);
          this.siteRowIdsForSiteIden.push(element.rowId);
          this.siteIdsForFilter.push(element.rowId);
          if(this.accessPointIdsForRaft.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForRaft.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForSaer.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForSaer.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForLatam.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForLatam.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForRnaipl.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForRnaipl.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForC2b.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForC2b.push(`'${element.identifier}'`);
          }
          this.identifierLoad=false
        });
        this.pagedTotalItem = data0['count'];
        this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
        if(data0['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
          this.pageHeight = data0['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
        }else{
          this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
        }
        if(from == 'pagination'){
          this.getSiteAssignmentData(this.siteAssnRowIdsIden,page,'first','iden');
          this.getAccessPointData(this.siteRowIdsForSiteIden,page,'second','iden');
          this.getSiteRaftCodes(this.accessPointIdsForRaft);
          this.getSiteSaerCodes(this.accessPointIdsForSaer);
          this.getSiteLatamCodes(this.accessPointIdsForLatam);
          this.getSiteRnaiplCodes(this.accessPointIdsForRnaipl);
          this.getSiteC2bCodes(this.accessPointIdsForC2b)
        }
      }else{
        this.noDataShown();
      }
    });
  }

  keyUpGetVendorCodeData(page=1,from){
    let searchV = this.identifierValueModel.trim();
    this.identifierLoad=true
    this.siteServices.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=ASUSI_CODE&identifierValue=*${searchV}*&_page=${page}&_pagesize=${this.maxPageSize}`).subscribe(data3 => {
      this.accessPointRowId = [];
      this.accessPointIdsForRaft = "";
      this.accessPointIdsForRaft = [];
      if(data3['pageCount'] > 0){
        this.gotKeyUpData = true;
        data3['access-point-identifiers'].forEach(element2 => {
          if(this.accessPointRowId.indexOf(element2.accessPointIdentifier) == -1){
            this.accessPointRowId.push(element2.accessPointIdentifier);            
          }
          this.accessPointIdsForRaft.push(`'${element2.siteIdentifier}'`);
          this.nissanCodeValues=element2.identifierValue.split("#");
          console.info("nissan vals", this.nissanCodeValues);
          this.sitesiDvalDropDown1.push(this.nissanCodeValues[1]);
        });
        this.pagedTotalItem = data3['count'];
        this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
        if(data3['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
          this.pageHeight = data3['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
        }else{
          this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
        }
        if(from == 'pagination'){
          this.getAccessPointData(this.accessPointIdsForRaft,page,'first','raft');
        }
      }else{
        this.noDataShown();
      }
    });
  }

  getSitesData(rowIds,mainPage,when,what,page =1,subscribeData = []){
    console.info('sites called');
    if(rowIds.length > 0){
      this.siteServices.getSites(`${this.Config.ApiSitesUrl}sites?rowId=in(${rowIds})&_page=${page}`).subscribe(data0 => {
        this.sitesData = [];
        if(data0['sites'].length > 0){
          data0['sites'].forEach(ele => {
            this.siteIdsForFilter.push(ele.rowId);
            ele['filterTrue'] = true;
            this.sitesData.push(ele);
            if(this.accessPointIdsForRaft.indexOf(`'${ele.identifier}'`) == -1){
              this.accessPointIdsForRaft.push(`'${ele.identifier}'`);
            }
            if(this.accessPointIdsForSaer.indexOf(`'${ele.identifier}'`) == -1){
              this.accessPointIdsForSaer.push(`'${ele.identifier}'`);  
            }
            if(this.accessPointIdsForLatam.indexOf(`'${ele.identifier}'`) == -1){
              this.accessPointIdsForLatam.push(`'${ele.identifier}'`);  
            }
            if(this.accessPointIdsForRnaipl.indexOf(`'${ele.identifier}'`) == -1){
              this.accessPointIdsForRnaipl.push(`'${ele.identifier}'`);  
            }
            if(this.accessPointIdsForC2b.indexOf(`'${ele.identifier}'`) == -1){
              this.accessPointIdsForC2b.push(`'${ele.identifier}'`);  
            }
          });
          if(data0['maxPage'] > 1 && data0['maxPage'] != page){
            this.getSitesData(rowIds,mainPage,when,what,page+1,subscribeData);
          }else if(data0['maxPage'] == page){
            this.getSiteRaftCodes(this.accessPointIdsForRaft);
            console.info("saer",this.accessPointIdsForSaer)
            this.getSiteSaerCodes(this.accessPointIdsForSaer);
            this.getSiteLatamCodes(this.accessPointIdsForLatam);
            this.getSiteRnaiplCodes(this.accessPointIdsForRnaipl);
            this.getSiteC2bCodes(this.accessPointIdsForC2b)
          }
        }
        console.info("final",when)
        if(when == 'final' && data0['maxPage'] == page){
          this.listFlag = true;
          this.loading = false;
        }







      });
    }else if(when == 'final'){
      this.listFlag = true;
      this.loading = false;
    }
  }

  getBvdIdData(rowIds,mainPage,when,page=1,subscribeData=[]){
    if(rowIds.length > 0){
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&businessEntityId=in(${rowIds})&_page=${page}`).subscribe(data0 => {
        if(data0['business-entity-identifiers'].length > 0){
          data0['business-entity-identifiers'].forEach(element => {
            if(element.endDate == ''){
              this.BvDIdData[element.businessEntityId] = element.value;
            }
          });
          if(data0['maxPage'] > 1 && data0['maxPage'] != page){
            this.getBvdIdData(rowIds,mainPage,when,page+1,subscribeData);
          }else if(data0['maxPage'] == page){

          }
        }
         if(when == 'final' && data0['maxPage'] == page){
          this.listFlag = true;
          this.loading = false;
        }
      });
    }else if(when == 'final'){
      this.listFlag = true;
      this.loading = false;
    }
  }

  getSiteAssignmentData(rowIds,pageMain,when,from,page = 1,subscribeData = [],loop='start',splitrowids=[],morethan20rec=false,remainingRows=[],pageChanged='yes'){
    let searchS = '?site=in(';
    if(from == 'bvd' || from == 'tax'){searchS = '?businessEntityId=in('}
    if(rowIds.length > 0){
      if(pageChanged == 'yes'){
        if(rowIds.length > SitesComponent.TWENTY){
          splitrowids = rowIds.slice(0,SitesComponent.TWENTY);
          remainingRows = rowIds.slice(SitesComponent.TWENTY,rowIds.length);
          morethan20rec = true;
        }else{
          splitrowids = rowIds;
          morethan20rec = false;
        }
      }
      this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments${searchS}${splitrowids})&_page=${page}`).subscribe(data0 => {
        if(loop == 'start'){
          this.siteRowidOnSiteAssn = [];
          this.siteAssignmentData = [];
          this.businessIdOnSiteAssn = [];
          this.businessEntityId = [];
        }
        if(data0['site-assignments'].length > 0){
          data0['site-assignments'].forEach(element => {
            let s =  element.site.href.split('/');
            if((this.siteAssignmentData[s[1]] && this.siteAssignmentData[s[1]]['status'] != 'VALIDATED') || !this.siteAssignmentData[s[1]] || (this.siteAssignmentData[s[1]]['status'] == 'ARCHIVED' && element.status == 'VALIDATED'))
            {
              if(element.status == 'ARCHIVED'){
                element['toggleRow'] = true;
                element['showRow'] = false;
              }else{
                element['toggleRow'] = false;
                element['showRow'] = true;
              }
              this.businessEntityId.push(element.businessEntityId);
              this.siteAssignmentData[s[1]] = element;
              this.businessIdOnSiteAssn[element.businessEntityId] = s[1];
              this.siteRowidOnSiteAssn.push(s[1]);
            }
          });
          if(data0['maxPage'] > 1 && data0['maxPage'] != page){
            this.getSiteAssignmentData(rowIds,pageMain,when,from,page+1,subscribeData,'continue',splitrowids,morethan20rec,remainingRows,'no');
          }else if(data0['maxPage'] == page){
            if(morethan20rec == true){
              this.getSiteAssignmentData(remainingRows,pageMain,when,from,1,subscribeData,'continue',splitrowids,morethan20rec,remainingRows,'yes');
            }
            if(from == 'accesspoints'){
              this.getBvdIdData(this.businessEntityId,pageMain,'third');
            }
            if(from =='bvd'){
              this.getSitesData(this.siteRowidOnSiteAssn,pageMain,'second','no');
              this.getAccessPointData(this.siteRowidOnSiteAssn,pageMain,'final','no');
            }
            if(from =='tax'){
              this.getSitesData(this.siteRowidOnSiteAssn,pageMain,'second','no');
              this.getAccessPointData(this.siteRowidOnSiteAssn,pageMain,'final','no');
              this.getBvdIdData(this.businessEntityIdforTax,pageMain,'final');
            }
            if(from == 'raft' || from == 'iden'|| from == 'saer' || from == 'c2b' || from == 'latam' || from == 'rnaipl'){
              this.getBvdIdData(this.businessEntityId,pageMain,'final');
            }
          }
        }
        else if(searchS == '?site=in('){
          console.info('in search is..');
          rowIds.forEach(ele => {
            if(this.siteAssignmentData[this.siteRowIdOnSiteIden[ele]] == undefined){
              this.siteAssignmentData[this.siteRowIdOnSiteIden[ele]] = [];
            }
            this.siteAssignmentData[this.siteRowIdOnSiteIden[ele]].businessEntityCompanyId = undefined;
          });
          if(from == 'raft' || from == 'iden' || from == 'saer' || from == 'c2b' || from == 'latam' || from == 'rnaipl'){
            this.loading = false;
            this.listFlag = true;
          }
        }else{

          this.loading = false;
        }

        if(when == 'final' && data0['maxPage'] == page){
          this.listFlag = true;
          this.loading = false;
        }
      },_error => {
        this.listFlag = false;
        this.loading = false;
      });
    }else if(when == 'final'){
      this.listFlag = true;
      this.loading = false;
    }
  }

  getAccessPointData(rowIds,page,when,what,acpPage=1,subscribeData=[],loop='start',rowForSiteAssn=[],mainEntranceIds=[]){
    let searchS = '?realEstateAssetId=in(';
    if((this.identifierTypeModel == 'RAFT_CODE' || this.identifierTypeModel == 'vendor-code' || this.identifierTypeModel =='SAER_CODE' || this.identifierTypeModel =='AP_C2B_CODE' || this.identifierTypeModel == 'AP_LATAM_CODE' || this.identifierTypeModel == 'AP_RNAIPL_CODE') && this.sitesNameModel.length == 0 && this.siteSearchCountryModel.length == 0 && this.identifierValueModel != ''){searchS = '?siteIdentifier=in('}
    if(rowIds.length > 0){
      if(loop == 'start'){
        this.accessPointDataNew = "";
        this.accessPointDataNew = [];
        this.forRaftSiteIdentifier = [];
      }
      this.siteServices.getAccessPoints(`${this.Config.ApiSitesUrl}access-points${searchS}${rowIds})&_page=${acpPage}`).subscribe(data0 => {
        if(data0['access-points'].length > 0){
          data0['access-points'].forEach(element => {
            if(element.endDate == ''){
              if(this.forRaftSiteIdentifier.indexOf(element.realEstateAssetId) == -1){
                this.forRaftSiteIdentifier.push(element.realEstateAssetId);
              }
              if(rowForSiteAssn.indexOf(`'SupSiteService:${element.realEstateAssetId}'`) == -1){
                rowForSiteAssn.push(`'SupSiteService:${element.realEstateAssetId}'`);
              }
              if(element.activeStatus != 'ARCHIVED'){
                if(element.irnAuthor!='IRN-70907'){
                  if(this.accessPointDataNew[element.realEstateAssetId] == undefined){
                    this.accessPointDataNew[element.realEstateAssetId] = [];
                  }
                  if(this.accessPointDataNew[element.realEstateAssetId][element.type]){
                    let so = this.accessPointDataNew[element.realEstateAssetId][element.type]
                    this.accessPointDataNew[element.realEstateAssetId][element.type] = so + 1;
                  }else{
                    this.accessPointDataNew[element.realEstateAssetId][element.type] = 1;
                  }
                }
              }

                if(mainEntranceIds.indexOf(element.rowId) == -1){
                  mainEntranceIds.push(element.rowId);
                }
                this.siteRowIdsOnMainEntrance[element.realEstateAssetId] = element.rowId;

            }
          });
          if(data0['maxPage'] > 1 && data0['maxPage'] != acpPage){
            this.getAccessPointData(rowIds,page,when,what,acpPage+1,subscribeData,'continue',rowForSiteAssn,mainEntranceIds);
          }else if(data0['maxPage'] == acpPage){
            if(what == 'raft'){
              this.getSitesData(this.forRaftSiteIdentifier,page,'no','no');
              this.getSiteAssignmentData(rowForSiteAssn,page,'no','raft');
            }
            if(what == 'saer'){
              this.getSitesData(this.forRaftSiteIdentifier,page,'no','no');
              this.getSiteAssignmentData(rowForSiteAssn,page,'no','saer');
            }
            if(what == 'latam'){
              this.getSitesData(this.forRaftSiteIdentifier,page,'no','no');
              this.getSiteAssignmentData(rowForSiteAssn,page,'no','latam');
            }
            if(what == 'rnaipl'){
              this.getSitesData(this.forRaftSiteIdentifier,page,'no','no');
              this.getSiteAssignmentData(rowForSiteAssn,page,'no','rnaipl');
            }
            if(what == 'c2b'){
              this.getSitesData(this.forRaftSiteIdentifier,page,'no','no');
              this.getSiteAssignmentData(rowForSiteAssn,page,'no','c2b');
            }
            this.getMainEntranceIds(mainEntranceIds);


          }
        }
        if(when == 'final' && data0['maxPage'] == acpPage){
          this.listFlag = true;
          this.loading = false;
        }
      });
    }else if(when == 'final'){
      this.listFlag = true;
      this.loading = false;
    }
  }

  noDataShown(){
    this.listFlag = false;
    this.loading = false;
    this.identifierLoad=false
  }

  classifyPagination(page){
    this.filterCheckQua.forEach(ele => {
      this[ele] = false;
    });
    this.showFilterQualifiers = false;
    this.siteIdsForFilter = [];
    if(this.sitesNameModel != '' || this.siteSearchCountryModel != ''){
      this.OnKeyDownForSiteName(page,'pagination');
    }
    else if(this.identifierValueModel != ''){
      this.OnkeyDownNg2Fn(page,'pagination');
    }else if(this.selectedStatusModel != ''){
      this.searchSiteStatus(page);
    }else if(this.selectedWorkflowStatusModel != ''){
      this.searchSiteWorkflowStatus(page);
    }else if(this.identifierValueModel.trim() == '' && this.sitesNameModel.trim() == '' && this.siteSearchCountryModel.trim() == ''){
      this.searchSiteWithoutFilter(page);
    }
  }


  selectChangeHandler(event: any) {

    this.siteTypeChange = true;
    this.sitesData = [];
    this.listFlag = false;

    this.sitesNameModel = "";
    this.sitesNameModellabel = "";
    this.CompanyStatusAll = [];
    this.statusDropdown = false;
    this.selectedStatusModel = '';
    this.workflowDropdown = false;
    this.selectedWorkflowStatusModel = '';
    this.delayResponse.setValue('');
    if(event.value == 'access-points'){this.minSearchLengthIdentifier = SitesComponent.MIN_SEARCH_LENGTH_LONG}
    else if(event.value == 'allianceSiteId'){this.minSearchLengthIdentifier = SitesComponent.MIN_SEARCH_LENGTH_LONG}
    else if(event.value == 'BVDID'){this.minSearchLengthIdentifier = SitesComponent.MIN_SEARCH_LENGTH_SHORT}
    else if(event.value == 'RAFT_CODE'){this.minSearchLengthIdentifier = SitesComponent.MIN_SEARCH_LENGTH_SHORT}
    else if(event.value == 'AP_C2B_CODE'){this.minSearchLengthIdentifier = SitesComponent.MIN_SEARCH_LENGTH_SHORT}
    else if(event.value == 'vendor-code'){this.minSearchLengthIdentifier = SitesComponent.MIN_SEARCH_LENGTH_SHORT}
    else if(event.value == 'AP_RNAIPL_CODE'){this.minSearchLengthIdentifier = SitesComponent.MIN_SEARCH_LENGTH_SHORT}
    else if(event.value == 'site_status'){this.statusDropdown = true;}
    else if(event.value == 'workflow_status'){this.workflowDropdown = true;}
  }

  selectedStatusChange(event:any){
    this.selectedStatusModel = event.target.value;
  }
  onInputCleared(e){
    if(e=='name'){
    this.siteNamesDropDown = [];
    } else if(e=='country'){
      this.siteSearchCountryDatas = []
      this.siteSearchCityDisable=true
    } else if(e=='country1'){
      this.cityDisable=true
    } else {
      this.sitesSearchCityDropDown = []
    }
  }

  onItemKey(event) {
    if (event["key"] !== 'Enter') {
      this.enterKey=true;
    }
  }

  getChangeHandler() {
    this.sitesDataLists = [];
    this.data = [];

    this.filterCheckQua.forEach(ele => {
      this[ele] = false;
    });
    if(this.identifierValueModel != "") {
      this.searchSiteIdentifierEnter(1);
    }
    if(this.selectedStatusModel != ''){
      this.searchSiteStatus();
    }
    if(this.selectedWorkflowStatusModel != ''){
      this.searchSiteWorkflowStatus();
    }
    if(this.sitesNameModel.trim().length >= SitesComponent.MIN_SEARCH_LENGTH_SHORT || (this.siteSearchCountryModel.trim().length >= SitesComponent.MIN_SEARCH_LENGTH_SHORT && this.siteSearchSelectedCountry != 'failed')) {
      this.searchSiteNameEnter(1);
    }
    if(this.identifierValueModel.trim() == '' && this.sitesNameModel.trim() == '' && this.siteSearchCountryModel.trim() == '' && this.selectedStatusModel.trim() == '' && this.selectedWorkflowStatusModel.trim() == ''){
      this.searchSiteWithoutFilter();
    }
  }

  resetSelectedFields(resetparam: any) {
    if (resetparam == "identifierValueModel") {
      this.delayNameResponse.setValue('')
      this.sitesNameModel = "";
      this.sitesNameModellabel = "";
      this.sitesiDvalDropDown1 = [];
    }else if (resetparam == "sitesNameModellabel") {
      this.delayResponse.setValue('')
      this.identifierValueModel = "";
      this.sitesiDvalDropDown1 = [];
    }else if(resetparam == 'country'){
      this.delaySiteSearchResCountry.setValue('');
      this.gotKeyUpData = false;
    }else if(resetparam == 'city'){
      this.delaySiteSearchResCity.setValue('');
      this.siteSearchSelectedCity = "failed";
      this.gotKeyUpData = false;
    }else{
      this.filterCheckQua.forEach(ele => {
        this[ele] = false;
      });
      this.listFlag = false;
      this.siteSearchCountryModel = '';
      this.siteSearchCityModel = '';
      this.sitesNameModel = "";
      this.identifierValueModel = "";
      this.sitesNameModellabel = "";
      this.sitesiDvalDropDown1 = [];
      this.sitesSearchCountryDropDown = [];
      this.sitesSearchCityDropDown = [];
      this.sitesData = [];
      this.delaySiteSearchResCity.setValue('');
      this.delayResponse.setValue('')
      this.delayNameResponse.setValue('');
      this.delaySiteSearchResCountry.setValue('');
      this.loading = false;
      this.filterSiteModel = '';
      this.selectedStatusModel = '';
      this.selectedWorkflowStatusModel = '';
      this.clearAllArrays()
    }
  }
  resetCreateSiteFields(selectedField) {
    console.info(selectedField);
    if (selectedField == 'siteAdditionalAddress') this.siteAdditionalAddress = '';
    if (selectedField == 'siteAdditionalAddressInfo') this.siteAdditionalAddressInfo = '';
    if (selectedField == 'siteStreetModel') this.siteStreetModel = '';
    if (selectedField == 'siteCityModel') this.siteCityModel = '';
    if (selectedField == 'siteCountryModel') {this.delayResCountry.setValue(''),this.delayResCity.setValue('')};
    if (selectedField == 'siteNameFieldModel') this.siteNameFieldModel = '';
    if (selectedField == 'siteShortNameFieldModel') this.siteShortNameFieldModel = '';
    if (selectedField == 'sitePostcodedModel') this.sitePostcodedModel = '';
    if (selectedField == 'gpslat') this.gpsValueModelLat = '';
    if (selectedField == 'gpslon') this.gpsValueModelLon = '';
    if (selectedField == 'wayNumberModel') this.wayNumberModel = '';
    if (selectedField == 'territorialDivisionModel') this.territorialDivisionModel = '';
    let expo = this.regExObjForSitesCreation[selectedField];
    this[expo] = false;
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
    localStorage.setItem('siteBatchRunning','no');
    localStorage.setItem('mainEntrBatchRunning','no');
  }

  onIdentivalueSelect(selected,model) {
    if(model == 'id'){
    if (
      selected != undefined &&
      selected != null &&
      selected != undefined
    ) {
      this.identifierValueModel = selected;
    } else if (
      selected != undefined &&
      selected != null &&
      typeof this.sitesids[selected] != "undefined"
    ) {
      this.identifierValueModel = selected;
    } else {
      this.identifierValueModel = "";
    }
    }
    else if(model == 'name'){
      if (
      selected != undefined &&
      selected != null &&
      selected != undefined
    ) {
      this.sitesNameModel = selected;
    } else if (
      selected != undefined &&
      selected != null &&
      typeof this.sitesids[selected] != "undefined"
    ) {
      this.sitesNameModel = selected;
    } else {
      this.sitesNameModel = "";
    }
    }
  }

  returnZero() {
    return 0
  }


  CreateSitesFirst() {
    this.siteNameFieldModel = '';
    this.siteShortNameFieldModel = '';
    this.siteNameFieldModelError = false;
    this.siteShortNameFieldModelError = false;
    this.siteCountryModel = '';
    this.siteCountryModelError = false;
    this.siteCityModel = '';
    this.siteCityModelError = false;
    this.siteStreetModel = '';
    this.siteStreetModelError = false;
    this.siteAdditionalAddress = '';
    this.siteAdditionalAddressInfo = '';
    this.saveDatas = 'Save';
    this.gpsValueModelLat = '';
    this.gpsValueModelLon = '';
    this.wayNumberModel = '';
    this.territorialDivisionModel = '';
    this.siteCityModelRegExError = false;
    this.wayNumberModelRegExError = false;
    this.siteAdditionalAddressRegExError = false;
    this.siteAdditionalAddressInfoRegExError = false;
    this.sitePostcodedModelRegExError = false;
    this.territorialDivisionModelRegExError = false;
    this.siteStreetModelRegExError = false;
    this.sitePostcodedModel = '';
    this.sitePostcodeModelError = false;
    this.disableSiteCreateBtn = false;
    this.siteNameModelRegExError = false;
    this.siteShortNameModelRegExError = false;
    this.latDegVal = '';
    this.latMinVal = '';
    this.latSecVal = '';
    this.northSouthModel = '';
    this.longDegVal = '';
    this.longMinVal = '';
    this.longSecVal = '';
    this.eastWestModel = '';
  }
  
  getCountriesList(event: any, page = 1) {
    const countrySearchText = (event || '').trim().toUpperCase();
    if (/^[A-Z]{2} - .+/.test(countrySearchText)) {
      this.countryLoad1 = false;
      return;
    }
    if(page === 1){
      this.CaptCountry = "";
      this.CaptCountry = [];
      this.CountryNameKeyId="";
      this.CountryNameKeyId=[];
      this.countryLoad1 = true;
    }
    if(countrySearchText.length >= 1){
      const searchQuery = countrySearchText.length <= SitesComponent.TWO ? `countryCode=${countrySearchText}` : `countryName=*${countrySearchText}*`;
      this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?${searchQuery}&_page=${page}&_pagesize=50`).subscribe((data: any) => {
        if(data['count']>0){
          data['countries'].forEach(element => {
            const displayValue = `${element.countryCode.toUpperCase()} - ${element.countryName}`;
            const captain_exist = this.CaptCountry.indexOf(displayValue);
            if(captain_exist == -1) {
              this.CaptCountry.push(displayValue);
              this.CountryNameKeyId[element.countryName] = element;
            }
          });
        }
        const maxPage = Number(data['maxPage'] ?? data['totalPages'] ?? page);
        if(maxPage > page){
          this.getCountriesList(countrySearchText, page + 1);
          return;
        }
        this.countryLoad1 = false;
      });
    } else {
      this.CaptCountry = [];
      this.countryLoad1 = false;
    }
  }

  getCityList(event: any) {
    this.cityLoad1=true
    if(this.selectedCountry!="failed" &&event.length>=SitesComponent.TWO){
      let split=this.siteCountryModel.split(" - ");
      this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${split[0]}&name=*${this.siteCityModel}*&_page=1&_pagesize=20`).subscribe((data: any) => {
        data['cities'].sort((item) => {
          return event.toUpperCase().indexOf(item.name.toUpperCase()) > -1 ? -1 : 1;
         })
        if(data['count']>0){
          this.CityNameKeyId="";
          this.CityNameKeyId=[];
          this.CaptCity = "";
          this.CaptCity = [];
          data['cities'].forEach(element => {
            this.CaptCity.push({
              name: element.name.toUpperCase(),
              latitude: element.latitude || '',
              longitude: element.longitude || '',
              adminZoneCode: element.adminZoneCode || '',
              adminZoneName: element.adminZoneName || '',
              adminZoneCode2: element.adminZoneCode2 || '',
              adminZoneName2: element.adminZoneName2 || ''
            });
            this.CityNameKeyId[element.name.toUpperCase()] = element;
            this.cityLoad1=false            
          });
        } else {
          this.CaptCity = [];
          this.cityLoad1=false
        }
      });
    } else {
      this.CaptCity = [];
      this.cityLoad1=false
    }
  }

  onCountryeSelect(selected) {
    if(selected) {
      this.selectedCountry = selected;
      this.siteCountryModelError = false;
      this.siteCityModel = "";
      this.cityDisable = false;
      this.countryLoad1=false;
    } else {
      this.selectedCountry = "failed";
      this.siteCountryModelError = true;
      this.siteCityModel = "";
      this.cityDisable = true;
    }
  }

  onCityeSelect(selected) {
    if(selected) {
      this.selectedCity = selected
      this.siteCityModelError = false;
      this.cityLoad1=false
    } else {
      this.selectedCity = "failed";
      this.siteCityModelError = true;
    }
  }

  saveSitesDetails() {
    if (
      this.siteNameFieldModel != "" &&
      this.siteNameFieldModel != undefined &&
      this.siteShortNameFieldModel != "" &&
      this.siteShortNameFieldModel != undefined &&
      this.siteCountryModel != "" &&
      this.siteCountryModel != undefined &&
      this.siteCityModel != "" &&
      this.siteCityModel != undefined &&
      this.siteStreetModel != "" &&
      this.siteStreetModel != undefined &&
      this.selectedCountry != "failed" &&
      this.siteCityModelRegExError == false && 
      this.wayNumberModelRegExError == false &&
      this.siteStreetModelRegExError == false &&
      this.siteAdditionalAddressRegExError == false &&
      this.siteAdditionalAddressInfoRegExError == false &&
      this.territorialDivisionModelRegExError == false &&
      this.siteNameModelRegExError == false &&
      this.siteShortNameModelRegExError == false
    ) {
      this.validationSuccess = true;





      let date = new Date();
      document.getElementById('btnForSiteCreateSteps').click();
      this.disableSiteCreateBtn = true;
      this.saveDatas = "Save...";
      this.citySelection = this.loadingSteps;
      this.siteCreation = this.loadingSteps;
      this.acpCreation = this.loadingSteps;
      let split=this.selectedCountry.split(" - ");
      this.finalSiteCreation = this.loadingSteps;
      let countryId = this.CountryNameKeyId[split[1]]['rowId'];
      let countryCode = this.CountryNameKeyId[split[1]]['countryCode'];
      let cntryName = this.CountryNameKeyId[split[1]]['countryName'];

      if(this.selectedCity == "failed") {
        this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${countryCode}&name=${this.siteCityModel.toUpperCase()}&_page=1&_pagesize=20`).subscribe((cityData: any) => {
          if(cityData['count']==1){
            this.citySelection = this.successSteps;
            let cityId = cityData['cities'][0]["rowId"];
            this.saveSiteInformation(countryId, cityId);
          }else if(cityData['count']==0){
            const cityDatas = {
              countryCode: countryCode,
              name: this.siteCityModel.toUpperCase(),
              active: "1",
              countryName: cntryName,
              countryId: countryId,
              postalCode : this.sitePostcodedModel
            };
            this.countryService.createCities(`${this.Config.ApiCountryUrl}cities`, cityDatas).subscribe((dataCity: any) => {
              this.citySelection = this.cityNewSteps;
              let cityId = dataCity["rowId"];
              this.saveSiteInformation(countryId, cityId);
            },error => {
              this.citySelection = `${this.dangerSteps}Error ${error.status} ${date}${this.endSpanSteps}`;
              this.siteCreation = `${this.dangerSteps}Error ${this.endSpanSteps}`;
              this.acpCreation = `${this.dangerSteps}Error ${this.endSpanSteps}`;
              this.finalSiteCreation = `${this.dangerSteps}Error ${this.endSpanSteps}`;
            });
          }else{
            this.siteCityModelError = true;
          }
        });
      } else {
        this.citySelection = this.successSteps;
        let cityId = this.CityNameKeyId[this.selectedCity]["rowId"];
        this.saveSiteInformation(countryId, cityId);
      }
    } else {
      if (this.siteNameFieldModel == "") {
        this.siteNameFieldModelError = true;
      } else {
        this.siteNameFieldModelError = false;
      }
      if (this.siteShortNameFieldModel == "") {
        this.siteShortNameFieldModelError = true;
      } else {
        this.siteShortNameFieldModelError = false;
      }
      if (this.siteCountryModel == "" || this.selectedCountry == "failed") {
        this.siteCountryModelError = true;
      } else {
        this.siteCountryModelError = false;
      }
      if (this.siteCityModel == "") {
        this.siteCityModelError = true;
      } else {
        this.siteCityModelError = false;
      }
      if (this.siteStreetModel == "") {
        this.siteStreetModelError = true;
      } else {
        this.siteStreetModelError = false;
      }





    }
  }

  saveSiteInformation(countryId, cityId) {
    let temp = this.siteAdditionalAddress;
    if(temp.length <= SitesComponent.ADDRESS_CHUNK_LENGTH){   ////add new line after 35 characters....
      for (let i =temp.length; i < SitesComponent.ADDRESS_CHUNK_LENGTH; i++){
        this.siteAdditionalAddress =  `${this.siteAdditionalAddress} `;
      }
    }
    let str1 =  this.siteAdditionalAddress;
    let str2 = this.siteAdditionalAddressInfo;
    this.siteAdditionalAddressInfoModel= str1+str2;
    const siteDatas = {
      cityId: cityId,
      countryId: countryId,
      activeStatus: "ACTIVE",
      name: this.siteNameFieldModel,
      usualName: this.siteShortNameFieldModel,
      effectiveDate: this.apiService.getTodayDate(),
      "irnAuthor":"IRN-71016",
      "siaAuthor":"IAF",
      "isMergingSite" : this.varIsMergingSite,
    };
    let date = new Date();
    this.siteServices.createSite(`${this.Config.ApiSitesUrl}sites`, siteDatas).subscribe((dataSite: any) => {
      let site_row_id = dataSite["rowId"];
      this.siteCreation = this.successSteps;
      const accessPDatas = {
        activeStatus: "ACTIVE",
        realEstateAssetId: site_row_id,
        type: "P14",
        label: this.siteNameFieldModel,
        effectiveDate: this.apiService.getTodayDate(),
        "irnAuthor":"IRN-71016",
        "siaAuthor":"IAF",
        activity : 'A10'
      };
      this.siteServices.createAccessPoint(`${this.Config.ApiSitesUrl}access-points`, accessPDatas).subscribe((dataAccessP: any) => {
        let access_point_row_id = dataAccessP["rowId"];
        this.acpCreation = this.successSteps;
        const geoADatas = {
          additionalInformation: this.siteAdditionalAddressInfoModel,
          streetName: this.siteStreetModel,
          postalCode : this.sitePostcodedModel,
          cityId: cityId,
          countryId: countryId,
          wayNumber : this.wayNumberModel,
          territorialDivision : this.territorialDivisionModel,
          "irnAuthor":"IRN-71016",
          "siaAuthor":"IAF"
        };
        this.addressService.createGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses`,geoADatas).subscribe((dataGeoA: any) => {
          let geo_adress_row_id = dataGeoA["rowId"];
          const accessPointDatas = {
            accessPointId: access_point_row_id,
            addressId: geo_adress_row_id
          }
          if(this.gpsValueModelLat != '' && this.gpsValueModelLat != undefined && this.gpsValueModelLon != '' && this.gpsValueModelLon != undefined){
            const gpsDatas = { 'accessPointId' : access_point_row_id, 'latitude' : this.gpsValueModelLat,'longitude' : this.gpsValueModelLon.toString()}
            this.addressService.createGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses`, gpsDatas).subscribe((dataGeoA:any) => {
              let geo_adress_row_id2 = dataGeoA['rowId'];
              const accessPointDatas = {accessPointId:access_point_row_id, addressId:geo_adress_row_id2};
              this.siteServices.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe((_dataAccessPoint:any) => {
              });
            });
          }
          this.siteServices.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`,accessPointDatas).subscribe((_dataAccessPoint: any) => {
            this.finalSiteCreation = this.successSteps;
            setTimeout(function(){
              document.getElementById('createSitesModalPopup').click();
              document.getElementById('closeSiteCreationStepsModal').click();
              this.router.navigateByUrl(`/site-details/${site_row_id}/${undefined}`);
            }.bind(this),SitesComponent.ONE_SECOND_MS)
          });
        });
      });
      this.addSiteCategoryToAssignment(site_row_id);
      window.document.getElementById("closeSCBtn").click();
      this.saveDatas = "Save";
    },error => {
      this.finalSiteCreation = `${this.dangerSteps}Error${error.status} ${date}${this.endSpanSteps}`;
      this.siteCreation = `${this.dangerSteps}Error${error.status} ${date}${this.endSpanSteps}`;
      this.acpCreation = `${this.dangerSteps}Error${error.status} ${date}${this.endSpanSteps}`;
    });
  }

  addSiteCategoryToAssignment(site_row_id){
    const newCategory = { "realEstateAssetId" : site_row_id, "categoryId" : this.newCategoryAssignment , "categoryName" : this.newCategoryName}
    this.siteServices.createRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments`,newCategory).subscribe(_data012 => {

    });
  }


  resetOtherFields(value,event){
    if(value == 'identifiers'){
      this.sitesNameModel = '';
      this.delayNameResponse.setValue('');
      this.filterSiteModel = '';
      this.siteSearchCityModel = '';
      this.siteSearchCountryModel = '';
      if(event["keyCode"] != SitesComponent.KEY_ENTER){
        this.siteTypeChange = false;
      }
    }else if(value == 'name'){
      this.identifierValueModel = '';
      // this.identifierTypeModel = '';
      this.delayResponse.setValue('');
      this.siteTypeChange = false;
      this.filterSiteModel = '';
    }else if(value == 'filter'){
      this.sitesNameModel = '';
      this.delayNameResponse.setValue('');
      this.siteSearchCityModel = '';
      this.siteSearchCountryModel = '';
      this.siteTypeChange = false;
      this.identifierValueModel = '';
    }
  }

  downloadLogFile(){
    let element = document.getElementById('excelTableLog');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Site Assignment Batch');
    XLSX.writeFile(wb, 'SiteLogFile.xlsx');
  }

  /**END Sites Assignment Batch workflow */

  /**START sites search with country and city */
   getSiteSearchCountriesList(event: any, page = 1, subscribeData = []) {
    if(/^[A-Z]{1,3} - .+/i.test(event)){
      return;
    }
    const countrySearchText = (event || '').trim().toUpperCase();
    if(countrySearchText.length >= 1){
      if(page === 1){
        this.sitesData = [];
        this.sitesNameDropDown = of([]);
        this.gotKeyUpData = false;
        this.countryLoad=true
        this.listFlag = false;
      }
      const searchQuery = countrySearchText.length <= SitesComponent.TWO ? `countryCode=${countrySearchText}` : `countryName=*${countrySearchText}*`;
      this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?${searchQuery}&_page=${page}&_pagesize=50`).subscribe((data: any) => {
        if(data['count']>0){
          data['countries'].forEach(element => {
            subscribeData.push(element);
          });
        }
        const maxPage = Number(data['maxPage'] ?? data['totalPages'] ?? page);
        if(maxPage > page){
          this.getSiteSearchCountriesList(countrySearchText,page + 1,subscribeData);
        }else{
          this.sitesSearchCountryDropDown="";
          this.sitesSearchCountryDropDown=[];
          this.siteSearchCountryData = "";
          this.siteSearchCountryData = [];
          subscribeData.forEach(element => {
            let displayValue = `${element.countryCode.toUpperCase()} - ${element.countryName}`;
            let captain_exist = this.sitesSearchCountryDropDown.indexOf(displayValue);
            if(captain_exist == -1) {
              this.sitesSearchCountryDropDown.push(displayValue);
              this.siteSearchCountryData[element.countryName] = element;
            }
          });
          this.countryLoad=false
          this.siteSearchCountryDatas=this.sitesSearchCountryDropDown
        }
      });
    } else {
      this.sitesSearchCountryDropDown = [];
      this.siteSearchCountryDatas = [];
      this.countryLoad = false;
    }
  }

  getSiteSearchCityList(event: any) {
    if(this.siteSearchSelectedCountry!="failed" &&event.length>=SitesComponent.TWO){
      this.gotKeyUpData = false;
      this.sitesData = [];
      this.cityLoad = true;
      this.sitesNameDropDown = [];
      this.listFlag = false;      
      let split=this.siteSearchCountryModel.split(" - ");
      this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${split[0]}&name=*${this.siteSearchCityModel}*&_page=1&_pagesize=20`).subscribe((data: any) => {
        if(data['count']>0){
          this.siteSearchCityData="";
          this.siteSearchCityData=[];
          this.sitesSearchCityDropDown = "";
          this.sitesSearchCityDropDown = [];
          data['cities'].forEach(element => {
            this.sitesSearchCityDropDown.push(element.name);
            this.siteSearchCityData[element.name] = element;
            this.cityLoad = false;
          });
        } else {
          this.sitesSearchCityDropDown = [];
          this.cityLoad = false;
        }
      });
    } else {
      this.sitesSearchCityDropDown = [];
    }
  }

  siteSearchonCountryeSelect(selected) {
    console.info("...")
    if(selected) {
      this.siteSearchSelectedCountry = selected
      this.siteSearchCityModel = "";
      this.siteSearchCityDisable = false;
    } else {
      this.siteSearchSelectedCountry = "failed";
      this.siteSearchCityModel = "";
      this.siteSearchCityDisable = true;
    }
  } 

  siteSearchonCityeSelect(selected) {
    if(selected) {
      this.siteSearchSelectedCity = selected
    } else {
      this.siteSearchSelectedCity = "failed";
    }
  }
  /**END sites search with country and city */

  /**START regex check for sites creation */
  checkForRegExSitesCreation(_event,expression,model){


    
    if(/^\s/.test(expression)){
      this[model] = expression.trimStart();
      return false;
    }
    this[model] = expression.replace(/(\r\n|\n|\r)/gm,"");
    let modelsVal = this.regExObjForSitesCreation[model];
    let modelsOri = this.sitesCreationModelObj[model];
    if(expression.length > 0){
      this[modelsOri] = false;
      if(!expression.match(/^[a-zA-Z 0-9\.\,\/\-\(\)]*$/gm)){

        this[modelsVal] = true;
      }else{
        this[modelsVal] = false;
      }
    }else{
      this[modelsVal] = false;
    }
  }
  /**END regex check for sites creation */

  /**START regex check for Site Short Name creation */
 checkForRegExSiteShortCreation(_event, expression, model) {
  
  if (/^\s/.test(expression)) {
    this[model] = expression.trimStart();
    return false;
  }


  this[model] = expression.replace(/(\r\n|\n|\r)/gm, "");

  let modelsVall = this.regExObjForSitesCreation[model];
  let modelsOrii = this.sitesCreationModelObj[model];

  if (expression.length > 0) {
    this[modelsOrii] = false;

  
    if (!expression.match(/^[a-zA-Z0-9 ]*$/gm)) {
      this[modelsVall] = true; 
    } else {
      this[modelsVall] = false; 
    }
  } else {
    this[modelsVall] = false; 
  }
}

/**END regex check for Site Short Name creation */


  /**START toggle site parentage status */
  toggleSitesDataStatus(event){
    let toggleEL = event.srcElement.checked;
    this.sitesData.forEach(ele => {
      if(this.siteAssignmentData[ele.rowId]){
        if(this.siteAssignmentData[ele.rowId].status == 'ARCHIVED'){
          this.siteAssignmentData[ele.rowId].showRow = !toggleEL;
        }
        if(this.siteAssignmentData[ele.rowId].toggleRow == true){
          this.siteAssignmentData[ele.rowId].showRow = !toggleEL;
        }
      }
    });
  }
  /**END toggle site parentage status */

    /**START new cpy alcor batch */
  siteAssnBatchFn(page :any=1,param='',pagesize:any=SitesComponent.TWENTY,maxpage?){

    let isProcess = localStorage.getItem('siteBatchProcessingPage');

    if(param == 'check' && this.siteBatchIsRunning == true){
      document.getElementById('btnForSiteAssignmentBatch').click();
      return false;
    }
    if(isProcess != null && isProcess != '' && param != 'continue' && param != 'continueNoC'){
      this.siteBatchPageHolder = isProcess;
      document.getElementById('btnForSiteContinue').click();
    }else if(param == 'continue' || isProcess == '' || isProcess == null || param == 'continueNoC'){
      if(param != 'continueNoC'){
        document.getElementById('btnForSiteAssignmentBatch').click();
      }
      if(param == 'continue'){
        this.stopAlcorCpyBatch = false;
      }
      console.info(this.stopAlcorCpyBatch,page,maxpage);
      if(this.stopAlcorCpyBatch == false && ((page <= maxpage || maxpage == undefined) || page == 1)){

        this.pageBatchNo = page;

        this.aliasTextDisp = '<img src="assets/images/loading.gif" alt="loading...">';
        if(page == maxpage){
          this.showDownloadLog = true;
        }else{
          this.showDownloadLog = false;
        }
        let simArr = [1,2,3,4,5,6,7];
        simArr.forEach((e,_index) => {
          this.batchObj[e] = 'notDone';
        });

          this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?_page=${page}&_pagesize=${pagesize}`).subscribe(data => {
          console.info('api 1');
          localStorage.setItem('siteBatchRunning','yes');
          this.siteBatchIsRunning = true;
          if(data['maxPage'] == page){
            this.showDownloadLog = true;
          }
          localStorage.setItem('siteBatchProcessingPage',page.toString());
          let cpyIdForAlcor = [];
          if(data['pageCount'] > 0){

            data['companies'].forEach(element => {
              this.allCompanyData[element.rowId] = (element);
              if(cpyIdForAlcor.indexOf(element.rowId) == -1){
                cpyIdForAlcor.push(element.rowId);
              }
            });
            this.batchObj[1] = 'done';
          }
          if(cpyIdForAlcor.length > 0){
            this.batchGetCompanyIdens(cpyIdForAlcor,data['maxPage'],page);
          }else{
            this.batchObj[1] = 'doneFor';
            this.fnToCallNextPage(page,maxpage);
          }
        });
      }
    }
  }

  batchGetCompanyIdens(cpyIdForAlcor,maxPage,page,Curpage=1,cpyAlcorValOnRow:any=[],allAlcorValsWithApos=[],allAlcorVals=[]){
    this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierKeyName=ALCOR&linkedCompanyId=in(${cpyIdForAlcor})&_page=${Curpage}`).subscribe(data1 => {
      console.info('api 2');
      if(data1['company-identifiers'].length > 0){
        data1['company-identifiers'].forEach(element1 => {
          if(this.cpyDataOnAlcorVal[element1.value] == undefined){
            this.cpyDataOnAlcorVal[element1.value] = [];
          }
          this.cpyDataOnAlcorVal[element1.value] = element1.linkedCompanyId;
          if(cpyAlcorValOnRow[element1.linkedCompanyId] == undefined){
            cpyAlcorValOnRow[element1.linkedCompanyId] = [];
          }
          cpyAlcorValOnRow[element1.linkedCompanyId].push(element1.value);
          if(allAlcorValsWithApos.indexOf(element1.value) == -1){
            allAlcorValsWithApos.push(`'${element1.value}'`);
          }
          if(allAlcorVals.indexOf(element1.value) == -1){
            allAlcorVals.push(element1.value);
          }
        });
        if(data1['maxPage'] > 1 && data1['maxPage'] != Curpage){
          this.batchGetCompanyIdens(cpyIdForAlcor,maxPage,page,Curpage+1,cpyAlcorValOnRow,allAlcorValsWithApos,allAlcorVals);
        }else if(data1['maxPage'] == Curpage){
          this.batchObj[2] = 'done';
          if(allAlcorValsWithApos.length > 0){
            this.batchGetRealEstateAssigns(allAlcorValsWithApos,allAlcorVals,maxPage,page);
          }else{
            this.batchObj[2] = 'doneFor';
            this.fnToCallNextPage(page,maxPage);
          }
        }
      }else{
        this.batchObj[2] = 'doneFor';
        this.fnToCallNextPage(page,maxPage);
      }
    });
  }

  batchGetRealEstateAssigns(allAlcorValsWithApos,allAlcorVals,maxPage,page,Curpage=1,siteRowIds=[],alcorMainData:any=[]){
    this.siteServices.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?businessIdentifierValue=in(${allAlcorValsWithApos})&_page=${Curpage}`).subscribe(data2 => {
      console.info('api 3');
      if(data2['real-estate-asset-identifiers'].length > 0){
        data2['real-estate-asset-identifiers'].forEach(element3 => {
          if(siteRowIds.indexOf(`'SupSiteService:${element3.realEstateAssetId}'`) == -1){
            siteRowIds.push(`'SupSiteService:${element3.realEstateAssetId}'`);
          }
          if(this.alcorValWithSiteRowId[element3.businessIdentifierValue] == undefined){
            this.alcorValWithSiteRowId[element3.businessIdentifierValue] = [];
          }
          this.alcorValWithSiteRowId[element3.businessIdentifierValue].push(element3.realEstateAssetId);
          if(this.siteValueonAlcor[element3.realEstateAssetId] == undefined){
            this.siteValueonAlcor[element3.realEstateAssetId] = [];
          }
          this.siteValueonAlcor[element3.realEstateAssetId] = element3.businessIdentifierValue;
          if(alcorMainData[element3.businessIdentifierValue] == undefined){
            alcorMainData[element3.businessIdentifierValue] = [];
          }
          alcorMainData[element3.businessIdentifierValue].push(element3);
        });
        if(data2['maxPage'] > 1 && data2['maxPage'] != Curpage){
          this.batchGetRealEstateAssigns(allAlcorValsWithApos,allAlcorVals,maxPage,page,Curpage+1,siteRowIds,alcorMainData);
        }else if(data2['maxPage'] == Curpage){
          this.batchObj[3] = 'done';
          this.getSiteAssignmentDataRows(siteRowIds,alcorMainData,allAlcorVals,page,maxPage);
          this.fnToCallNextPage(page,maxPage);



        }
      }else{
        this.batchObj[3] = 'doneFor';
        this.fnToCallNextPage(page,maxPage);
      }
    });    
  }

  fnToCallNextPage(page,maxpage){
    let simArr = [1,2,3,4,5,6,7];
    simArr.forEach((e,index) => {
      if(this.batchObj[e] == 'done' && index+1 == simArr.length){
        this.siteAssnBatchFn(+page+1,'continueNoC',SitesComponent.TWENTY,maxpage);
      }else if(this.batchObj[1] == 'doneFor' || this.batchObj[2] == 'doneFor' || this.batchObj[3] == 'doneFor' || this.batchObj[4] == 'doneFor' || this.batchObj[5] == 'doneFor'){
        this.siteAssnBatchFn(+page+1,'continueNoC',SitesComponent.TWENTY,maxpage);
        return false;
      }
    });
  }
  
  getSiteAssignmentDataRows(rowIds,alcorMainData,allAlcorVals,page,maxPage,splitrowids=[],morethan20rec=false,remainingRows=[],pageChanged='yes',CurPage=1){
    console.info('api 4');
    if(rowIds.length > 0){




      if(pageChanged == 'yes'){
        if(rowIds.length > SitesComponent.TWENTY){
          splitrowids = rowIds.slice(0,SitesComponent.TWENTY);
          remainingRows = rowIds.slice(SitesComponent.TWENTY,rowIds.length);
          morethan20rec = true;
        }else{
          splitrowids = rowIds;
          morethan20rec = false;
        }
      }
      this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=in(${splitrowids})&_page=${CurPage}`).subscribe(data => {
        if(data['site-assignments'].length > 0){
          data['site-assignments'].forEach(element => {
            if(element.status == 'VALIDATED'){
              let siteE = element.site.href.split('/');
              if(this.siteAssignmentDataAll[siteE[1]] == undefined){
                this.siteAssignmentDataAll[siteE[1]] = [];
              }
              this.siteAssignmentDataAll[siteE[1]] = element;
              if(this.siteAssnRowIds.indexOf(siteE[1]) == -1){
                this.siteAssnRowIds.push(siteE[1]);
              }
            }
          });
        }else{
          this.batchObj[4] = 'doneFor';
        }
        if(data['maxPage'] > 1 && data['maxPage'] != CurPage){
          this.getSiteAssignmentDataRows(rowIds,alcorMainData,allAlcorVals,page,maxPage,splitrowids,morethan20rec,remainingRows,'no',CurPage+1);
        }else if(data['maxPage'] == CurPage){
          if(morethan20rec == true){
            this.getSiteAssignmentDataRows(remainingRows,alcorMainData,allAlcorVals,page,maxPage,splitrowids,morethan20rec,remainingRows,'yes',1);
          }else{
            this.batchObj[4] = 'done';
            this.sortAlcorAndLookForSitesData(alcorMainData,this.siteAssnRowIds,allAlcorVals,maxPage,page);
            this.fnToCallNextPage(page,maxPage);
          }
        }
      });
    }else{
      this.batchObj[4] = 'doneFor';
    }
  }

  sortAlcorAndLookForSitesData(mainData,_siteAssnRowIds,allAlcorVals,maxPage,page){

    let noSiteAssnRows = [];

    allAlcorVals.forEach(element => {
      if(mainData[element]){
        if(mainData[element].length > 0){
          let allEqualParams = true;
          for(let i = 0;i < mainData[element].length; i++){
            if(mainData[element][0]['businessIdentifierName'] == mainData[element][i]['businessIdentifierName'] &&
              mainData[element][0]['effectiveDate'] == mainData[element][i]['effectiveDate'] &&
              mainData[element][0]['endDate'] == mainData[element][i]['endDate']){
              }else{ //do not initiate cpy link
                allEqualParams = false;
              }
          }
          if(allEqualParams){
            this.alcorValWithSiteRowId[element].forEach(ele => {
              if(this.siteAssnRowIds.indexOf(ele) == -1){
                if(noSiteAssnRows.indexOf(ele) == -1){
                  noSiteAssnRows.push(ele);
                }
              }
            });
          }else{
            if(this.tableDataForSiteAssnBatch.indexOf(this.cpyDataOnAlcorVal[element]) == -1){
              this.tableDataForSiteAssnBatch.push(this.cpyDataOnAlcorVal[element]);
            }
          }
        }
      }
    });

    this.initiateCpyLink(noSiteAssnRows,1,maxPage,page);
  }

  initiateCpyLink(noSiteAssnRows,page=1,maxPage,Mainpage){
    console.info(noSiteAssnRows);
    if(noSiteAssnRows.length > 0){
      this.siteServices.getSites(`${this.Config.ApiSitesUrl}sites?rowId=in(${noSiteAssnRows})&_page=${page}`).subscribe(data1 => {
        console.info('api 5');
        if(data1['sites'].length > 0){
          data1['sites'].forEach(ele => {
            this.sitesAllData[ele.rowId] = ele;
          });
        }else{
          this.batchObj[5] = 'done';
        }
        if(data1['maxPage'] > 1 && data1['maxPage'] != page){
          this.initiateCpyLink(noSiteAssnRows,page+1,maxPage,Mainpage);
        }else if(data1['maxPage'] == page){
          this.batchObj[5] = 'done';
          this.createCpyLinkFor(noSiteAssnRows,maxPage,Mainpage);
        }
      });
    }else{
      this.batchObj[5] = 'doneFor';
      this.fnToCallNextPage(Mainpage,maxPage);
    }

  }

  createCpyLinkFor(siteIds,maxPage,Mainpage){
    siteIds.forEach((ele,index) => {




      if(this.sitesAllData[ele]){
        let tempBusinessRowId;
        let bvdIdAutomatic;
        bvdIdAutomatic = `BVD-${this.sitesAllData[ele].identifier}`;
        const const1 = {
          'companyId' :  this.cpyDataOnAlcorVal[this.siteValueonAlcor[ele]],
          'isHQ'      : 'N'
        }
        console.info('in last');

        this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`,const1).subscribe(data => {
          tempBusinessRowId = data['row_id'];
          const const2 = {
                "businessEntityIdentifierTypeId"    :"1",
                "businessEntityIdentifierTypeName"  :"BVD ID",
                "startDate"                         : this.apiService.getTodayDate(),
                "businessEntityId"                 : tempBusinessRowId,
                "value"                             : bvdIdAutomatic
          }
          this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD%20ID&value=${bvdIdAutomatic}&_page=1`).subscribe(data => {
            if(data['pageCount'] == 0){
              this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`,const2).subscribe(_data2 => {
                  if(index+1 == siteIds.length){
                    this.batchObj[7] = 'done';
                    this.fnToCallNextPage(Mainpage,maxPage);
                  }

              });
            }else{
              this.supplierService.deleteBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${data['business-entity-identifiers'][0]['row_id']}`).subscribe(_data1 => {
                this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`,const2).subscribe(_data2 => {
                  if(index+1 == siteIds.length){
                    this.batchObj[7] = 'done';
                    this.fnToCallNextPage(Mainpage,maxPage);
                  }

                });
              });
            }
          });

          const const3 = {
            "validityStartDate": this.apiService.getTodayDate(),
            "status" : "VALIDATED",
            "businessEntityId" : tempBusinessRowId
          }
          this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${ele}`,const3).subscribe(_data3 => {
            if(index+1 == siteIds.length){
              this.batchObj[6] = 'done';
              this.fnToCallNextPage(Mainpage,maxPage);
            }
          });
        },_error => {
          this.batchObj[6] = 'done';
          this.batchObj[7] = 'done';
        });
      }else{
        if(index+1 == siteIds.length){
          this.batchObj[6] = 'done';
          this.batchObj[7] = 'done';
        }
        this.fnToCallNextPage(Mainpage,maxPage);
      }
    });
  }

  changeStopBatch(){
    this.stopAlcorCpyBatch=true;
    this.aliasTextDisp = 'Stopped!';
    this.pageBatchNo = '-';
    this.showDownloadLog = true;
    this.siteBatchIsRunning = false;
    localStorage.setItem('siteBatchRunning','no');
  }








  /**START filter qualifier as selected */
  filterQualifiers(){
    let quaToFilter = [];
    let validSiteIds = [];
    this.filteredStatushighlight =false
    this.filterCheckQua.forEach(ele => {
      if(this[ele] == true){
        let type = ele.split('_');
        quaToFilter.push(type[0]);
        this.filteredStatushighlight =true
      }
    });
    console.info('filter',quaToFilter);
    if(quaToFilter.length > 0){


      this.siteIdsForFilter.forEach(element => {
        let forTEle = true;
        for(let i=0; i< quaToFilter.length; i++){
          if(this.accessPointDataNew[element]){
            if(this.accessPointDataNew[element][quaToFilter[i]] != undefined && this.accessPointDataNew[element][quaToFilter[i]] != null){
            }else{
              forTEle = false;
            }
          }else{
            forTEle = false;
          }
        }
        if(forTEle == true){
          if(validSiteIds.indexOf(element) == -1){
            validSiteIds.push(element);
          }
        }
      });
      this.sitesData.forEach(elements => {
        if(validSiteIds.indexOf(elements.rowId) != -1){
          elements['filterTrue'] = true;
        }else{
          elements['filterTrue'] = false;
        }
      });
    }else{
      this.sitesData.forEach(elements => {
        elements['filterTrue'] = true;
      });
    }
    this.showFilterQualifiers = false;
    console.info('filtered data',this.sitesData);
  }

  setCheckboxVal(id){
    this[`${id}_qualifier`] = !this[`${id}_qualifier`];
  }
  /**END filter qualifier as selected */

  /**START show site raft code in search */
  getSiteRaftCodes(rowIds,page=1,splitrowids=[],morethan20rec = false,remainingRows=[]){
    if(rowIds.length > 0){
      if(rowIds.length > SitesComponent.TWENTY){
        splitrowids = rowIds.slice(0,SitesComponent.TWENTY);
        remainingRows = rowIds.slice(SitesComponent.TWENTY,rowIds.length);
        morethan20rec = true;
      }else{
        morethan20rec = false;
        splitrowids = rowIds;
      }
      this.siteServices.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=RAFT_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {
        if(data['access-point-identifiers'].length > 0){
          data['access-point-identifiers'].forEach(e => {

            if(this.siteRaftCodeValOnRowId[e.siteIdentifier] == undefined){
              this.siteRaftCodeValOnRowId[e.siteIdentifier] = [];
            }
            if(this.siteRaftCodeValOnRowId[e.siteIdentifier].indexOf(e.identifierValue) == -1){
              this.siteRaftCodeValOnRowId[e.siteIdentifier].push(e.identifierValue);
            }
          });
        }
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getSiteRaftCodes(rowIds,page+1);
        }else if(data['maxPage'] == page){
          if(morethan20rec == true){
            this.getSiteRaftCodes(remainingRows,1,splitrowids,morethan20rec,remainingRows);
          }
        }
      });
    }
  }
  /**END show site raft code in search */

  /**Start show site saer code in search */

  getSiteSaerCodes(rowIds,page=1,splitrowids=[],morethan20rec = false,remainingRows=[]){
    if(rowIds.length > 0){
      if(rowIds.length > SitesComponent.TWENTY){
        splitrowids = rowIds.slice(0,SitesComponent.TWENTY);
        remainingRows = rowIds.slice(SitesComponent.TWENTY,rowIds.length);
        morethan20rec = true;
      }else{
        morethan20rec = false;
        splitrowids = rowIds;
      }
      this.siteServices.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=SAER_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {        
        if(data['access-point-identifiers'].length > 0){
          data['access-point-identifiers'].forEach(e => {
            if(this.siteSaerCodeValOnRowId[e.siteIdentifier] == undefined){
              this.siteSaerCodeValOnRowId[e.siteIdentifier] = [];
            }
            if(this.siteSaerCodeValOnRowId[e.siteIdentifier].indexOf(e.identifierValue) == -1){
              this.siteSaerCodeValOnRowId[e.siteIdentifier].push(e.identifierValue);
            }
          });
        }
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getSiteSaerCodes(rowIds,page+1);
        }else if(data['maxPage'] == page){
          console.info("this.siteSaerCodeValOnRowId",this.siteSaerCodeValOnRowId)
          if(morethan20rec == true){
            this.getSiteSaerCodes(remainingRows,1,splitrowids,morethan20rec,remainingRows);
          }
        }
      });
    }
  }
/**END show site saer code in search */
/**Start show site c2b code in search */

getSiteC2bCodes(rowIds,page=1,splitrowids=[],morethan20rec = false,remainingRows=[]){
  if(rowIds.length > 0){
    if(rowIds.length > SitesComponent.TWENTY){
      splitrowids = rowIds.slice(0,SitesComponent.TWENTY);
      remainingRows = rowIds.slice(SitesComponent.TWENTY,rowIds.length);
      morethan20rec = true;
    }else{
      morethan20rec = false;
      splitrowids = rowIds;
    }
    this.siteServices.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_C2B_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {        
      if(data['access-point-identifiers'].length > 0){
        data['access-point-identifiers'].forEach(e => {
          if(this.siteC2bCodeValOnRowId[e.siteIdentifier] == undefined){
            this.siteC2bCodeValOnRowId[e.siteIdentifier] = [];
          }
          if(this.siteC2bCodeValOnRowId[e.siteIdentifier].indexOf(e.identifierValue) == -1){
            this.siteC2bCodeValOnRowId[e.siteIdentifier].push(e.identifierValue);
          }
        });
      }
      if(data['maxPage'] > 1 && data['maxPage'] != page){
        this.getSiteC2bCodes(rowIds,page+1);
      }else if(data['maxPage'] == page){
        console.info("this.siteSaerCodeValOnRowId",this.siteC2bCodeValOnRowId)
        if(morethan20rec == true){
          this.getSiteC2bCodes(remainingRows,1,splitrowids,morethan20rec,remainingRows);
        }
      }
    });
  }
}
/**END show site saer code in search */
  /**START show main entrance address */
  getMainEntranceIds(rowIds,addressIds =[],page=1){
    if(rowIds.length > 0){
      this.siteServices.getAccessPointAddresses(`${this.Config.ApiSitesUrl}access-points-addresses?accessPointId=in(${rowIds})&_page=${page}`).subscribe(data => {
        if(data['access-points-addresses'].length > 0){
          data['access-points-addresses'].forEach(e => {
            if(e.addressType == 'GEOGRAPHICAL'){
              this.accessPointIdOnAddress[e.accessPointId] = e.addressId;
              addressIds.push(e.addressId);
            }
          });
          if(data['maxPage'] > 1 && data['maxPage'] != page){
            this.getMainEntranceIds(rowIds,addressIds,page+1);
          }else if(data['maxPage'] == page){
            this.getMainEntrAddresses(addressIds);
          }
        }
      });
    }
  }

  getMainEntrAddresses(rowIds,page=1){
    if(rowIds.length > 0){
      this.addressService.getGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses?rowId=in(${rowIds})&_page=${page}`).subscribe(data => {
        if(data['geographical-addresses'].length > 0){
          data['geographical-addresses'].forEach(e => {
            this.acpAddressDetOnRows[e.rowId] = e;
          });
          if(data['maxPage'] > 1 && data['maxPage'] != page){
            this.getMainEntrAddresses(rowIds,page+1);
          }
        }
      });
    }
  }
  /**END show main entrance address */

  /**START search sites without filter */
  searchSiteWithoutFilter(page=1){
    this.loading = true;
    this.sitesData = [];
    this.siteServices.getSites(`${this.Config.ApiSitesUrl}sites?_page=${page}&_pagesize=${SitesComponent.PAGE_SIZE_STANDARD}`).subscribe(data => {
      this.siteAssnRowIdsIden = "";
      this.siteAssnRowIdsIden = [];
      this.siteRowIdsForSiteIden = "";
      this.siteRowIdsForSiteIden = [];
      this.accessPointIdsForRaft = [];
      this.accessPointIdsForSaer = [];
      this.accessPointIdsForLatam = [];
      this.accessPointIdsForRnaipl = [];
      this.accessPointIdsForC2b = [];
      this.siteIdsForFilter = [];
      if(data['sites'].length > 0){
        this.pagedTotalItem = data['count'];
        this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
        if(data['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
          this.pageHeight = data['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
        }else{
          this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
        }
        data['sites'].forEach(element =>{
          element['filterTrue'] = true;
          this.sitesData.push(element);
          this.sitesNameDropDown.push(element.name)
          this.siteAssnRowIdsIden.push(`'SupSiteService:${element.rowId}'`);
          this.siteRowIdsForSiteIden.push(element.rowId);
          this.siteIdsForFilter.push(element.rowId);
          if(this.accessPointIdsForRaft.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForRaft.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForSaer.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForSaer.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForLatam.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForLatam.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForRnaipl.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForRnaipl.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForC2b.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForC2b.push(`'${element.identifier}'`);
          }
        });
        this.searchSiteNameEnter(page,'noFilter');
      }
    });
  }
  /**END search site without filter */

  openWorkflow(){
    let baseUrl1 = baseUrl
    if(baseUrl1==opeUrl || baseUrl1 == opewafUrl || baseUrl1 == opeNewwafUrl) {
      window.open(`${share}HOME`);
    }
    else if(baseUrl1==localUrl || baseUrl1== `${localUrl}/` || baseUrl1 == intUrl ) {
       window.open(`${dev}HOME`);
     }
     else{
       window.open(`${int}HOME`);
     }
  }

  /**START search using site status */
  searchSiteStatus(page=1){
    this.siteServices.getSites(`${this.Config.ApiSitesUrl}sites?_page=${page}&activeStatus=${this.selectedStatusModel}&_pagesize=${this.maxPageSize}`).subscribe( data => {
      this.siteAssnRowIdsIden = "";
      this.siteAssnRowIdsIden = [];
      this.siteRowIdsForSiteIden = "";
      this.siteRowIdsForSiteIden = [];
      this.accessPointIdsForRaft = [];
      this.accessPointIdsForSaer = [];
      this.accessPointIdsForLatam = [];
      this.accessPointIdsForRnaipl = [];
      this.accessPointIdsForC2b = [];
      this.siteIdsForFilter = [];
      this.sitesData = [];
      if(data['pageCount'] > 0){
        this.gotKeyUpData = true;
        this.pagedTotalItem = data['count'];
        this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
        if(data['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
          this.pageHeight = data['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
        }else{
          this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
        }

        data['sites'].forEach(element =>{
          element['filterTrue'] = true;
          this.sitesData.push(element);
          this.sitesNameDropDown.push(element.name)
          this.siteAssnRowIdsIden.push(`'SupSiteService:${element.rowId}'`);
          this.siteRowIdsForSiteIden.push(element.rowId);
          this.siteIdsForFilter.push(element.rowId);
          if(this.accessPointIdsForRaft.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForRaft.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForSaer.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForSaer.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForLatam.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForLatam.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForRnaipl.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForRnaipl.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForC2b.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForC2b.push(`'${element.identifier}'`);
          }
        });
      }else{
        this.loading = false;
      }
      this.getSiteAssignmentData(this.siteAssnRowIdsIden,page,'first','iden');
      this.getAccessPointData(this.siteRowIdsForSiteIden,page,'second','iden');
      this.getSiteRaftCodes(this.accessPointIdsForRaft);
      this.getSiteSaerCodes(this.accessPointIdsForSaer);
      this.getSiteLatamCodes(this.accessPointIdsForLatam);
      this.getSiteRnaiplCodes(this.accessPointIdsForRnaipl);
      this.getSiteC2bCodes(this.accessPointIdsForC2b)
      this.listFlag = true;
    });    
  }
  /**END search using site status */

  /**START search using workflow status */
  searchSiteWorkflowStatus(page=1){
    this.siteServices.getSites(`${this.Config.ApiSitesUrl}sites?_page=${page}&workflowStatus=${this.selectedWorkflowStatusModel}&_pagesize=${this.maxPageSize}`).subscribe( data => {
      this.siteAssnRowIdsIden = "";
      this.siteAssnRowIdsIden = [];
      this.siteRowIdsForSiteIden = "";
      this.siteRowIdsForSiteIden = [];
      this.accessPointIdsForRaft = [];
      this.accessPointIdsForSaer = [];
      this.accessPointIdsForLatam = [];
      this.accessPointIdsForRnaipl = [];
      this.accessPointIdsForC2b = [];
      this.sitesData = [];
      if(data['sites'].length > 0){
        data['sites'].forEach(element => {
          element['filterTrue'] = true;
          this.sitesData.push(element);
          if(this.siteAssnRowIdsIden.indexOf(`'SupSiteService:${element.rowId}'`) == -1){
            this.siteAssnRowIdsIden.push(`'SupSiteService:${element.rowId}'`);
          }
          if(this.siteRowIdsForSiteIden.indexOf(element.rowId) == -1){
            this.siteRowIdsForSiteIden.push(element.rowId);
          }
          this.siteIdsForFilter.push(element.rowId);
          if(this.accessPointIdsForRaft.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForRaft.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForSaer.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForSaer.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForLatam.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForLatam.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForRnaipl.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForRnaipl.push(`'${element.identifier}'`);
          }
          if(this.accessPointIdsForC2b.indexOf(`'${element.identifier}'`) == -1){
            this.accessPointIdsForC2b.push(`'${element.identifier}'`);
          }
        });
        this.pagedTotalItem = data['count'];
        this.pager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
        if(data['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
          this.pageHeight = data['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
        }else{
          this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
        }
      }else{
        this.loading = false;
      }
      this.getSiteAssignmentData(this.siteAssnRowIdsIden,page,'first','iden');
      this.getAccessPointData(this.siteRowIdsForSiteIden,page,'second','iden');
      this.getSiteRaftCodes(this.accessPointIdsForRaft);
      this.getSiteSaerCodes(this.accessPointIdsForSaer);
      this.getSiteLatamCodes(this.accessPointIdsForLatam);
      this.getSiteRnaiplCodes(this.accessPointIdsForRnaipl);
      this.getSiteC2bCodes(this.accessPointIdsForC2b)
      this.listFlag = true;
    });    
  }
  /**END search using workflow status */

  /**START UPLOAD NISSAN CODES */
  getFinalObject(str){


    let columns = str.slice(0, str.indexOf('\n')).split(/\;|\,/);
    this.headers=columns;


    const rows = str.slice(str.indexOf('\n') + 1).split(/\r\n/);
    this.rowLength=rows.length;
    
    const arr = rows.map(function (row) {
      let values = row.split(/\;|\,/);
      const el = columns.reduce(function (object, header, index) {
        object[header] = values[index];
        return object;
      }, {});
      return el;
    });

    return arr;
  }

  changeListener($event) {
    this.readThis($event.target);
  }
  readThis(inputValue: any) {
    this.fileToUpload = inputValue.files[0];

    let reader: FileReader = new FileReader();
    reader.readAsText(this.fileToUpload);
    reader.onload = (_e) => {
      let csv: any = reader.result;
      this.arrayOfObjects = this.getFinalObject(csv);
      console.info("columns",this.headers);
      this.uploadNissanCodes(this.arrayOfObjects,this.headers);
    }
  }  

  uploadNissanCodes(objj,header,page=1){
    let tempFileRaftCode;
    let codeDatas;
    let rfsNissanData=[];
    this.showDownloadLogForNissan = false;
    document.getElementById('btnForShowNissanCodeUploading').click();
    this.TextForCompleteUpload = 'Uploading';
    for (let i = 0; i < this.rowLength-1; i++) {
      if((objj[i][header[2]] != undefined) && (objj[i][header[3]] != undefined)){
        if((objj[i][header[2]].length == SitesComponent.SIX)){
          if((objj[i][header[3]].length == SitesComponent.TWO)){
            if((objj[i][header[4]].toLowerCase() == 'y') || (objj[i][header[4]].toLowerCase() == 'n')){
              tempFileRaftCode = objj[i][header[2]] + objj[i][header[3]];
              this.siteServices.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierValue=${tempFileRaftCode}&identifierTypeName=RAFT_CODE&accessPointType=P05&_page=${page}`).subscribe(data =>{
                if(data['access-point-identifiers'].length > 0){
                  data['access-point-identifiers'].forEach(element1 => {
                    if(element1.endDate == ''){
                      this.siteServices.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?accessPointRowId=${element1.accessPointRowId}&identifierTypeName=ASUSI_CODE&_page=${page}`).subscribe(data1 =>{
                        let tempFileNissanValues = `${objj[i][header[0]]}#${objj[i][header[1]]}#${objj[i][header[4]]}`;
                        if(data1['access-point-identifiers'].length > 0){
                          data1['access-point-identifiers'].forEach(el => {
                            if(rfsNissanData.indexOf(el.identifierValue)==-1){
                              rfsNissanData.push(el.identifierValue);
                            }
                          });
                          if(rfsNissanData.indexOf(tempFileNissanValues)==-1){
                            codeDatas = {
                              identifierId: this.siteIdentTypesData['ASUSI_CODE'],
                              sourceSystemId: "2",
                              identifierValue: tempFileNissanValues,
                              accessPointRowId : element1.accessPointRowId,
                              effectiveDate: this.apiService.getTodayDate(),
                            };
                            this.siteServices.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, codeDatas).subscribe(_data2 => {
                            });
                          }
                        }else{
                          codeDatas = {
                            identifierId: this.siteIdentTypesData['ASUSI_CODE'],
                            sourceSystemId: "2",
                            identifierValue: tempFileNissanValues,
                            accessPointRowId : element1.accessPointRowId,
                            effectiveDate: this.apiService.getTodayDate(),
                          };
                          this.siteServices.createAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers`, codeDatas).subscribe(_data3 => {
                          });
                        }
                      });
                    }
                  });
                }
              });
            }else{
              this.logFileArrayOfUploadErrors.push({'error' : `Warehouse syntax error: ${objj[i][header[4]]}`});
            }
          }else{
            this.logFileArrayOfUploadErrors.push({'error' : `RAFT Extension does not have TWO digits: ${objj[i][header[3]]}`});
          }
        }else{
          this.logFileArrayOfUploadErrors.push({'error' : `Renault Supplier Code does not consist of SIX digits: ${objj[i][header[2]]}`});
        }
      }
      if(i==(this.rowLength-1)-1){
        this.TextForCompleteUpload = "Uploading Completed";
        this.showDownloadLogForNissan = true;
      }
    }
  }

  getSiteIdenTypes(page = 1, subscribeData = []){
    this.siteServices.getIdentifierTypes(`${this.Config.ApiSitesUrl}identifier-types?_page=${page}`).subscribe(data => {
      if(data['identifier-types'].length > 0){
        data['identifier-types'].forEach( ele => {
          this.siteIdentTypesData[ele.name] = ele.rowId;
        });
        if(data['maxPage'] > 1 && data['maxPage'] != page){
          this.getSiteIdenTypes(page+1,subscribeData);
        }
      }
    });
  }
  
  downloadLogFileForNissan(){
    let element = document.getElementById('excelTableLogForNissan');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Upload Nissan Codes');
    XLSX.writeFile(wb, 'NissanCodesLogFile.xlsx');
  }
  /**END UPLOAD NISSAN CODES */
  
  /**START Export sites */
  ExportTOExcel(){
    let exportTo = [];
    this.sitesData.forEach(ele => {
      let obj = {};
      obj['Site Name'] = ele.name;
      obj['Site Status'] = ele.activeStatus.replace("CREATED","WAITING FOR APPROVAL");
      obj['Alliance Site ID'] = ele.identifier;
      if(this.siteAssignmentData[ele.rowId]){
        obj['BvD ID'] = this.BvDIdData[this.siteAssignmentData[ele.rowId].businessEntityId] 
      }
      obj['site rafts'] = JSON.stringify(this.siteRaftCodeValOnRowId[ele.identifier]);
      obj['Country'] = ele.countryName;
      obj['City'] = ele.cityName;
      if(this.acpAddressDetOnRows[this.accessPointIdOnAddress[this.siteRowIdsOnMainEntrance[ele.rowId]]]){
        obj['Street'] =this.acpAddressDetOnRows[this.accessPointIdOnAddress[this.siteRowIdsOnMainEntrance[ele.rowId]]].streetName + this.acpAddressDetOnRows[this.accessPointIdOnAddress[this.siteRowIdsOnMainEntrance[ele.rowId]]].additionalInformation;
      }
      if(this.siteAssignmentData[ele.rowId]){
        obj['Company Name'] = this.siteAssignmentData[ele.rowId].businessEntityCompanyLegalName;
      }
      if(this.siteAssignmentData[ele.rowId]){
        obj['Parentage'] =this.siteAssignmentData[ele.rowId].status.replace("VALIDATED", "ACTIVE");
      }
      if(this.accessPointDataNew[ele.rowId]){
        obj['Manufacturing'] = this.accessPointDataNew[ele.rowId]['P05'];
        obj['Invoicing'] = this.accessPointDataNew[ele.rowId]['P06'];
        obj['Picking'] = this.accessPointDataNew[ele.rowId]['P07'];
        obj['Customer'] = this.accessPointDataNew[ele.rowId]['P08'];
        obj['Quality Return'] = this.accessPointDataNew[ele.rowId]['P09'];
        obj['Ordering'] = this.accessPointDataNew[ele.rowId]['P11'];
        obj['Main Entrance'] = this.accessPointDataNew[ele.rowId]['P14'];
        obj['B2B Partner'] = this.accessPointDataNew[ele.rowId]['P18'];
        obj['Supply Chain EDI'] = this.accessPointDataNew[ele.rowId]['P19'];
      }
      exportTo.push(obj);
    });
    console.info('obj',exportTo);
    let todayDate = new Date();


    const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(exportTo);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Export');
    XLSX.writeFile(wb, `export${todayDate.getTime()}.xlsx`);
  }
  /**END Export sites */

  pageHeightStyle(){
    if(this.listFlag==true && this.sitesData.length>0){
      let myStyleClass = {  
        'height': `${this.pageHeight}px`,
        'overflow-y': 'scroll' 
      };  
      return myStyleClass;
    }
  }

  /**country info model starts here */
  countryInfoModel(page=1,subscribeData = []){
    this.countryInfoLoading=true;
    this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?_page=${page}`).subscribe((data: any) => {
      if (data['countries'].length > 0) {
        data['countries'].forEach(element1 => {
          subscribeData.push(element1);
        });
      }
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.countryInfoModel(page + 1,subscribeData);
      } else if (data['maxPage'] == page) {
        this.dataForDispCountryInfo = [];
        subscribeData.forEach(el => {
          const svg = `${el.countryFlag}`
          svgToPng(svg, (imgData) => {
            const pngImage = document.createElement('img');
            document.body.appendChild(pngImage);
            pngImage.src = imgData;
            document.body.removeChild(pngImage);
          });
          function svgToPng(svg, callback) {
            const url = getSvgUrl(svg);
            svgUrlToPng(url, (imgData) => {
              callback(imgData);
              if(el['flag'] == undefined){
                el['flag'] = [];
              }
              el['flag'] = imgData;
              URL.revokeObjectURL(url);
            });
          }
          function getSvgUrl(svg) {
            return URL.createObjectURL(new Blob([svg], {
              type: 'image/svg+xml'
            }));
          }
          function svgUrlToPng(svgUrl, callback) {
            const svgImage = document.createElement('img');

            svgImage.onload = () => {
              const canvas = document.createElement('canvas');
              canvas.width = SitesComponent.TWENTY_FIVE;
              canvas.height = SitesComponent.TWENTY_FIVE;
              const canvasCtx = canvas.getContext('2d');
              canvasCtx.drawImage(svgImage, 0, 0);
              const imgData = canvas.toDataURL('image/png');
              callback(imgData);

            };
            svgImage.src = svgUrl;
          }
          this.dataForDispCountryInfo.push(el);
        });
        this.dataForDispCountryInfo.sort((a, b) => (a.countryCode < b.countryCode ? -1 : 1))
        this.countryInfoLoading = false;
      }
    }, _error => {
      this.countryInfoLoading = false;
    });
  }
  /**country info model ends here*/
  
  /**start factories code display modal  */    
  FactoriesCodedisp(page=1,Factoriescode = []){
    this.FactoriescodeLoading=true;
    this.uniquefactcode=[];
    this.siteServices.getAccessPointAttachmentAttributes(`${this.Config.ApiSitesUrl}access-point-attachment-attributes?type=FACTORY_CODE&_page=${page}`).subscribe((data: any) => {
      if (data['access-point-attachment-attributes'].length > 0) {
        data['access-point-attachment-attributes'].forEach(element1 => {
          Factoriescode.push(element1.value.slice(SitesComponent.TWO));
        });
      }
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.FactoriesCodedisp(page + 1,Factoriescode);
      } else if(data['maxPage'] == page){
        Factoriescode.forEach(element => {
          if (!this.uniquefactcode.includes(element)) {
            this.uniquefactcode.push(element);
          }
        });
        this.FactoriescodeLoading=false;
        this.pagedTotalItem = this.uniquefactcode.length;
        this.factPager = this.pagerService.getPager(this.pagedTotalItem, page,SitesComponent.PAGE_SIZE_STANDARD);
        console.info(this.factPager);
        if(this.data['pageCount']<=SitesComponent.PAGE_COUNT_THRESHOLD){
          this.pageHeight = this.data['pageCount']*SitesComponent.PAGE_HEIGHT_ROW_FACTOR+SitesComponent.PAGE_HEIGHT_BASE_OFFSET;
        }else{
          this.pageHeight = SitesComponent.PAGE_HEIGHT_FALLBACK;
        }
        this.totalItems = this.uniquefactcode.length;
        this.FactoriesNamedisp();
      }
    }, _error => {
      this.FactoriescodeLoading = false;
    });
  }
  /**End factories code display modal */

  /**start factoriesname display */ 
  FactoriesNamedisp(){
    this.FactoriescodeLoading=false;
    this.uniquefactNameAndCode=[];
    this.uniquefactcode.forEach(element1 => {
      this.siteServices.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?identifierType=RAFT_ACCOUNT&businessIdentifierValue=${element1}` ).subscribe((data: any) => {
        if (data['real-estate-asset-identifiers'].length > 0) {
            this.uniquefactNameAndCode.push({'value':element1,'label':data['real-estate-asset-identifiers'][0].businessIdentifierName});
        }
        this.updatePaginatedSites()
      });
    });  
  }    
  /**End factoriesname display */

  onPageChange(page: number) {
    this.p = page;
    this.updatePaginatedSites();

  }
 
  updatePaginatedSites() {
    const startIndex = (this.p - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedSites = this.uniquefactNameAndCode.slice(startIndex, endIndex);
  }

  /** Start Add Main Entrance batch here */
  mainEntrBatchStartCheckOnStart(){
    this.timerForMainEntrBatchStart = SitesComponent.BATCH_START_DELAY_SEC;
    let checkVar = localStorage.getItem('mainEntrBatchRunning');
    let isProcess = localStorage.getItem('mainEntrBatchProcessingPage');
    if(checkVar == 'yes'){
      this.mainEntrBatchPageHolder = isProcess;
      document.getElementById('BtnForshowConfirmMainEntrStartBatch').click();
      const source = interval(SitesComponent.ONE_SECOND_MS);
      this.subscription = source.subscribe(_val => {
        this.timerForMainEntrBatchStart = this.timerForMainEntrBatchStart - 1;
        if(this.timerForMainEntrBatchStart == 0){
          document.getElementById('closeMainEntrStartBatch').click();
          this.addMainEntBatchFn(+isProcess,'continue',SitesComponent.TWENTY,undefined);
          this.subscription.unsubscribe();
        }
      });
    }
  }

  stopAddMainEntrBatch(){
    this.subscription.unsubscribe();
    this.stopMainEntrBatch = true;
    this.mainEntrBatchIsRunning = false;
    localStorage.setItem('mainEntrBatchRunning','no');
  }

  addMainEntBatchFn(page :any=1,param='',pagesize:any=SitesComponent.TWENTY,maxpage?){
    let isProcess = localStorage.getItem('mainEntrBatchProcessingPage');
    if(param == 'check' && this.mainEntrBatchIsRunning == true){
      document.getElementById('btnForMainEntrBatch').click();
      return false;
    }
    if(isProcess != null && isProcess != '' && param != 'continue' && param != 'continueNoC'){
      this.mainEntrBatchPageHolder = isProcess;
      document.getElementById('btnForMainEntrContinue').click();
    }else if(param == 'continue' || isProcess == '' || isProcess == null || param == 'continueNoC'){
      if(param != 'continueNoC'){
        document.getElementById('btnForMainEntrBatch').click();
      }
      if(param == 'continue'){
        this.stopMainEntrBatch = false;
      }
      console.info(this.stopMainEntrBatch,page,maxpage);
      if(this.stopMainEntrBatch == false && ((page <= maxpage || maxpage == undefined) || page == 1)){
        this.mainEntrpageBatchNo = page;
        this.mainEntrTextDisp = '<img src="assets/images/loading.gif" alt="loading...">';
        if(page == maxpage){
          this.showDownloadLogForMainEntr = true;
        }else{
          this.showDownloadLogForMainEntr = false;
        }
        let simArr = [1];
        simArr.forEach((e,_index) => {
          this.batchObjs[e] = 'notDone';
        });
        this.siteServices.getSites(`${this.Config.ApiSitesUrl}sites?_page=${page}&_pagesize=${pagesize}`).subscribe(data => {
          console.info('api 1');
          localStorage.setItem('mainEntrBatchRunning','yes');
          this.mainEntrBatchIsRunning = true;
          if(data['maxPage'] == page){
            this.showDownloadLogForMainEntr = true;
          }
          localStorage.setItem('mainEntrBatchProcessingPage',page.toString());
          let siteIds:any;

          if(data['pageCount'] > 0){
            data['sites'].forEach(element => {              
              if(element != null){
                siteIds=element.rowId;
                this.mainEntranceExists = false;
                this.checkForMainEntrance(siteIds,data['maxPage'],page)
              }
            });
            setTimeout(function(){
              this.batchObjs[1] = 'done';
              this.fnToCallNextPageAddMAinEntr(page,data['maxPage']);
            }.bind(this),SitesComponent.FIVE_THOUSAND_MS);
          }else{
            this.batchObjs[1] = 'doneFor';
            this.fnToCallNextPageAddMAinEntr(page,maxpage);
          }
        });
      }
    }
  }

  checkForMainEntrance(siteIds,maxPage,page,Curpage=1,subscribeData:any=[]){
    this.siteServices.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=in(${siteIds})&_page=${Curpage}`).subscribe( data1 => {
      console.info('api 2');
      if(data1['access-points'].length > 0){
        data1['access-points'].forEach(element1 => {
          if(element1.irnAuthor!='IRN-70907'){
            subscribeData.push(element1);
          }
        });
        if(data1['maxPage'] > 1 && data1['maxPage'] != Curpage){
          this.checkForMainEntrance(siteIds,maxPage,page,Curpage+1,subscribeData);
        }else if(data1['maxPage'] == Curpage){
          let accessPointsData=[];
          let accessPointsRowID = [];
          let labelValueArrays=[];
          this.mainEntranceExists = false;
          subscribeData.forEach( (element : any) => {
            if(labelValueArrays.indexOf(element.label) == -1){
              labelValueArrays.push(element.label);
            }
            accessPointsRowID.push(element.rowId);
            if(accessPointsData.indexOf(element) == -1){
              accessPointsData.push(element);
            }            
            if(element.type == 'P14'){
              this.mainEntranceExists = true;
            }
          });
          if(accessPointsRowID.length>0){
            if(this.mainEntranceExists==false){
              this.batchGetGpsAndStreet(accessPointsRowID,accessPointsData,labelValueArrays,maxPage,page);
            }
          }
        }
      }
    });
  }

  batchGetGpsAndStreet(accessPointsRowID,accessPointsData,labelValueArrays,maxPage,page,Curpage=1,allAddressIdsGeo=[],allAddressIdsGeoloc=[],allAddressIdsPostal=[]){    
    this.siteServices.getAccessPointAddresses(`${this.Config.ApiSitesUrl}access-points-addresses?accessPointId=in(${accessPointsRowID})&_page=${Curpage}`).subscribe(data2 =>{
      console.info('api 3');
      if(data2['access-points-addresses'].length > 0){
        data2['access-points-addresses'].forEach(element3 => {
          if(element3.addressType == 'GEOGRAPHICAL'){
            if(allAddressIdsGeo.indexOf(element3.addressId) == -1){
              allAddressIdsGeo.push(element3.addressId);
            }
          }
          if(element3.addressType == 'POSTAL'){
            if(allAddressIdsPostal.indexOf(element3.addressId) == -1){
              allAddressIdsPostal.push(element3.addressId);
            }
          }
          if(element3.addressType == 'GEOLOC'){
            if(allAddressIdsGeoloc.indexOf(element3.addressId) == -1){
              allAddressIdsGeoloc.push(element3.addressId);
            }
          }
        });
        if(data2['maxPage'] > 1 && data2['maxPage'] != Curpage){
          this.batchGetGpsAndStreet(accessPointsRowID,accessPointsData,labelValueArrays,maxPage,page,Curpage+1,allAddressIdsGeo,allAddressIdsGeoloc,allAddressIdsPostal);
        }else if(data2['maxPage'] == Curpage){          
          let allAddressGeoData;
          if(allAddressIdsGeo.length > 0){
            allAddressGeoData = [];
          }
          this.getGeographicalAddresses(allAddressIdsGeo,allAddressIdsPostal,allAddressIdsGeoloc,accessPointsData,labelValueArrays,page,maxPage,allAddressGeoData);
        }
      }
    });
  }

  getGeographicalAddresses(allAddressIdsGeo,allAddressIdsPostal,allAddressIdsGeoloc,accessPointsData,labelValueArrays,page,maxPage,allAddressGeoData=[],Curpage=1){
    this.addressService.getGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses?rowId=in(${allAddressIdsGeo})&_page=${Curpage}`).subscribe(data3 => {
      console.info("api 4");
      if(data3['geographical-addresses'].length > 0){
        data3['geographical-addresses'].forEach(e => {
          allAddressGeoData.push(e);
        });
      }
      if(data3['maxPage'] > 1 && data3['maxPage'] != Curpage){
        this.getGeographicalAddresses(allAddressIdsGeo,allAddressIdsPostal,allAddressIdsGeoloc,accessPointsData,labelValueArrays,page,maxPage,allAddressGeoData,Curpage+1);
      }else if(data3['maxPage'] == Curpage){       
        if(allAddressIdsPostal.length > 0){
          this.getPostalAddresses(allAddressIdsPostal,allAddressIdsGeoloc,accessPointsData,labelValueArrays,page,maxPage,allAddressGeoData);
        }else if(allAddressIdsGeoloc.length > 0){
          this.getGeolocAddresses(allAddressIdsGeoloc,accessPointsData,labelValueArrays,page,maxPage,allAddressGeoData);
        }else{
          this.createMainEntraceAcp(accessPointsData,labelValueArrays,allAddressGeoData);
        }
      }
    });
  }

  getPostalAddresses(allAddressIdsPostal,allAddressIdsGeoloc,accessPointsData,labelValueArrays,page,maxPage,allAddressGeoData,Curpage=1,allAddressPostalData=[]){
    this.addressService.getPostalAddresses(`${this.Config.ApiAddressUrl}postal-addresses?rowId=in(${allAddressIdsPostal})&_page=${Curpage}`).subscribe(data4 => {
      console.info('api 5');
      if(data4['postal-addresses'].length > 0){
        data4['postal-addresses'].forEach(ele => {
          allAddressPostalData.push(ele);
        });
      }
      if(data4['maxPage'] > 1 && data4['maxPage'] != Curpage){
        this.getPostalAddresses(allAddressIdsPostal,allAddressIdsGeoloc,accessPointsData,labelValueArrays,page,maxPage,allAddressGeoData,Curpage+1,allAddressPostalData);
      }else if(data4['maxPage'] == Curpage){
        if(allAddressIdsGeoloc.length > 0){
          this.getGeolocAddresses(allAddressIdsGeoloc,accessPointsData,labelValueArrays,page,maxPage,allAddressGeoData,allAddressPostalData);
        }else{
          this.createMainEntraceAcp(accessPointsData,labelValueArrays,allAddressGeoData,allAddressPostalData);
        }
      }
    });
  }

  getGeolocAddresses(allAddressIdsGeoloc,accessPointsData,labelValueArrays,page,maxPage,allAddressGeoData,allAddressPostalData=[],Curpage=1,allAddressGeoLocData=[]){
    this.addressService.getGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses?rowId=in(${allAddressIdsGeoloc})&_page=${Curpage}`).subscribe(data5 => {
      console.info('api 6');
      if(data5['geolocation-coordinates-addresses'].length > 0){
        data5['geolocation-coordinates-addresses'].forEach(e => {
          allAddressGeoLocData.push(e);
        });
      }else{
        this.createMainEntraceAcp(accessPointsData,labelValueArrays,allAddressGeoData,allAddressPostalData,allAddressGeoLocData);
      }
      if(data5['maxPage'] > 1 && data5['maxPage'] != Curpage){
        this.getGeolocAddresses(allAddressIdsGeoloc,accessPointsData,labelValueArrays,page,maxPage,Curpage+1);
      }else if(data5['maxPage'] == Curpage){
        this.createMainEntraceAcp(accessPointsData,labelValueArrays,allAddressGeoData,allAddressPostalData,allAddressGeoLocData);
      }
    });
  }

  createMainEntraceAcp(accessPointsData,labelValueArrays,allAddressGeoData=[],allAddressPostalData=[],allAddressGeoLocData=[]){





    if(accessPointsData.length>0){
      if(allAddressGeoData.length > 1){
        this.logFileArrayOfAddMainEntrErrors.push({"site" : accessPointsData[0].siteIdentifier,'error' : "More than one Geographical Address"});
      }else if(allAddressPostalData.length > 1){
        this.logFileArrayOfAddMainEntrErrors.push({"site" : accessPointsData[0].siteIdentifier,'error' : "More than one Postal Address"});
      }else if(allAddressGeoLocData.length > 1){
        this.logFileArrayOfAddMainEntrErrors.push({"site" : accessPointsData[0].siteIdentifier,'error' : "More than one geolocation-coordinates"});
      }else if(labelValueArrays.length>1){
        this.logFileArrayOfAddMainEntrErrors.push({"site" : accessPointsData[0].siteIdentifier,'error' : "More than one Label Name"});
      }else if(labelValueArrays.length>0 && labelValueArrays[0]!=''){
        const siteDatas = {activeStatus:'ACTIVE',
                           realEstateAssetId: accessPointsData[0].realEstateAssetId,
                           type: 'P14',
                           label: labelValueArrays[0],
                           effectiveDate:this.apiService.getTodayDate(),
                           "irnAuthor":"IRN-71016",
                           "siaAuthor":"IAF",
                           "activity" : 'A10'
        }
        this.siteServices.createAccessPoint(`${this.Config.ApiSitesUrl}access-points`, siteDatas).subscribe(data => {
          let access_point_row_id = data['rowId'];          
          if(allAddressGeoData.length>0 && allAddressGeoData[0]!=''){
            const accessPointDatas1 = {accessPointId:access_point_row_id, addressId:allAddressGeoData[0].rowId};
            this.siteServices.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas1).subscribe((_dataAccessPoint1:any) => {
            });
          }      
          if(allAddressPostalData.length>0 && allAddressPostalData[0]!=''){
            const accessPointDatas2 = {accessPointId:access_point_row_id, addressId:allAddressPostalData[0].rowId};
            this.siteServices.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas2).subscribe((_dataAccessPoint2:any) => {
            });
          }      
          if(allAddressGeoLocData.length>0 && allAddressGeoLocData[0]!=''){
            const accessPointDatas3 = {accessPointId:access_point_row_id, addressId:allAddressGeoLocData[0].rowId};
            this.siteServices.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas3).subscribe((_dataAccessPoint3:any) => {
            });
          }
        });
      }
    }
  }

  changeStopBatchForMainEntr(){
    this.stopMainEntrBatch=true;
    this.mainEntrTextDisp = 'Stopped!';
    this.mainEntrpageBatchNo = '-';
    this.showDownloadLogForMainEntr = true;
    this.mainEntrBatchIsRunning = false;
    localStorage.setItem('mainEntrBatchRunning','no');
  }
  
  fnToCallNextPageAddMAinEntr(page,maxpage){    
    let simArr = [1];
    simArr.forEach((e,index) => {
      if(this.batchObjs[e] == 'done' && index+1 == simArr.length){
        this.addMainEntBatchFn(+page+1,'continueNoC',SitesComponent.TWENTY,maxpage);
      }else if(this.batchObjs[1] == 'doneFor'){
        this.addMainEntBatchFn(+page+1,'continueNoC',SitesComponent.TWENTY,maxpage);
        return false;
      }
    });
  }

  downloadLogFileForMAinEntr(){
    let element = document.getElementById('excelTableLogForMainEntr');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Add Main Entrance Batch');
    XLSX.writeFile(wb, 'mainEntranceLogFile.xlsx');
  }
  /** End Add Main Entrance batch here */
  dmsversdd(){
    let lat, lng, nordsud, estouest, latitude_degres, latitude_minutes, latitude_secondes, longitude_degres, longitude_minutes, longitude_secondes;
    if (this.northSouthModel=='South')
        nordsud = -1;
    else
        nordsud = 1;
    if (this.eastWestModel=='West')
        estouest = -1;
    else
        estouest = 1;
    latitude_degres = parseFloat(this.latDegVal) || 0;
    latitude_minutes = parseFloat(this.latMinVal) || 0;
    latitude_secondes = parseFloat(this.latSecVal) || 0;
    longitude_degres = parseFloat(this.longDegVal) || 0;
    longitude_minutes = parseFloat(this.longMinVal) || 0;
    longitude_secondes = parseFloat(this.longSecVal) || 0;
    lat = nordsud * (latitude_degres + latitude_minutes / SitesComponent.MINUTES_PER_DEGREE + latitude_secondes / SitesComponent.SECONDS_PER_DEGREE);
    lng = estouest * (longitude_degres + longitude_minutes / SitesComponent.MINUTES_PER_DEGREE + longitude_secondes / SitesComponent.SECONDS_PER_DEGREE);
    let tem1 = Math.round(lat * 1e7) / 1e7;
    this.gpsValueModelLat = tem1.toString();
    this.gpsValueModelLon = lng;








  }

  ddversdms() {
    let lat, lng, latdeg, latmin, latsec, lngdeg, lngmin, lngsec;
    lat = parseFloat(this.gpsValueModelLat) || 0;
    lng = parseFloat(this.gpsValueModelLon) || 0;
    console.info("lat",lat)
    console.info("lat",lng)


    if (lat >= 0)
        this.northSouthModel='North';
    if (lat < 0)
        this.northSouthModel='South';
    if (lng >= 0)
        this.eastWestModel='East';
    if (lng < 0)
        this.eastWestModel='West';












    lat = Math.abs(lat);
    lng = Math.abs(lng);
    latdeg = Math.floor(lat);
    latmin = Math.floor((lat - latdeg) * SitesComponent.MINUTES_PER_DEGREE);
    latsec = Math.round((((lat - latdeg - latmin / SitesComponent.MINUTES_PER_DEGREE) * 1e3 * SitesComponent.SECONDS_PER_DEGREE) / 1e3)*SitesComponent.DECIMAL_TENTH)/SitesComponent.DECIMAL_TENTH;
    lngdeg = Math.floor(lng);
    lngmin = Math.floor((lng - lngdeg) * SitesComponent.MINUTES_PER_DEGREE);
    lngsec = Math.floor((((lng - lngdeg - lngmin / SitesComponent.MINUTES_PER_DEGREE) * 1e3 * SitesComponent.SECONDS_PER_DEGREE) / 1e3)*SitesComponent.DECIMAL_TENTH)/SitesComponent.DECIMAL_TENTH;
    this.latDegVal = latdeg;
    this.latMinVal = latmin;
    this.latSecVal = latsec;
    this.longDegVal = lngdeg;
    this.longMinVal = lngmin;
    this.longSecVal = lngsec;
  }

  copyGpsdata(){
    if(this.selectedCity != "failed"){
      this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${this.siteCountryModel.split(' - ')[0]}&name=*${this.siteCityModel}*`).subscribe((data1: any) => {
        console.info("data1",data1['cities'])
        data1['cities'].forEach(element => {
          if(element.latitude !='' && element.longitude !=''){
            this.gpsValueModelLat =element.latitude.replace(",", ".");
            this.gpsValueModelLon=element.longitude.replace(",", ".");
            this.ddversdms();
            this.dmsversdd();  
          }else{
            document.getElementById('btnForNoGpsData').click();
          }              
        });
      }); 
    }else{
      this.siteCityModelError = true;
    }
  } 
  sort(key){
    this.key = key;
    this.reverse = !this.reverse;
  } 
}